export const TOKEN = 'token'
// token 时间戳
export const TIME_STAMP = 'timeStamp'
// 超时时长(毫秒) 两小时
export const TOKEN_TIMEOUT_VALUE = 2 * 3600 * 1000
// 国际化
export const LANG = 'language'
export const LegCode=['AGENT','CHB','DRAY','NVO','WHS','TRUCK','EXPRESS','RAILWAY','AIR']
export const freightForwarders=['deWell','fe','safround','ubi']
export const ContainerType=['20GP','40GP','40HQ','45HQ']
export const quoteLegColumns= [
    {
        title: 'msg.legCode.legcode',
        dataIndex: 'legcode',
        key: 'legcode',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.legcode - b.legcode,
    },
    {
        title: 'msg.drayage.vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.vendor - b.vendor,
    },
    {
        title: 'msg.drayage.fromArea',
        dataIndex: 'fromArea',
        key: 'fromArea',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.fromArea - b.fromArea,
    },
    {
        title: 'msg.drayage.toArea',
        dataIndex: 'toArea',
        key: 'toArea',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.toArea - b.toArea,
    },
    {
        title: 'msg.drayage.total',
        dataIndex: 'total',
        key: 'total',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.total - b.total,
    },
    /*{
        title: 'msg.quotes.rateL4',
        dataIndex: 'rateL4',
        key: 'rateL4',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rateL4 - b.rateL4,
    },*/
    {
        title: 'msg.action.operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
    }
]
export const drayDestType=['FBA','City']
export const drayDropType=['Live','Drop']
export const expressZones=['Zone 2','Zone 3','Zone 4','Zone 5','Zone 6','Zone 7','Zone 8']
export const yn=['Y','N']
export const uomSystem=['cm-kg','inch-lb']
export const uomCVT={inchToCM:2.54,kgToLb:2.205}
export const servicePortType=['Import','Export']
export const serviceCategory=['Door-To-Door','Port-To-Door','Door-To-Port','Port-To-Port']
export const mockBroker=['Broker-A','Broker-B','Broker-C']
export const originSrvFeeColum = [
    /*{
      title: 'msg.originSrvFee.vendor',
      dataIndex: 'vendor',
      key: 'vendor',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.vendor - b.vendor,
    },
    {
      title: 'msg.originSrvFee.pol',
      dataIndex: 'pol',
      key: 'pol',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.pol - b.pol,
    },
    {
      title: 'msg.originSrvFee.ctnrType',
      dataIndex: 'ctnrType',
      key: 'ctnrType',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.ctnrType - b.ctnrType,
    },*/
    {
        title: 'msg.originSrvFee.chargeDescription',
        dataIndex: 'chargeDescription',
        key: 'chargeDescription',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeDescription - b.chargeDescription,
    },
    {
        title: 'msg.originSrvFee.chargeType',
        dataIndex: 'chargeType',
        key: 'chargeType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeType - b.chargeType,
    },
    {
        title: 'msg.originSrvFee.rates',
        dataIndex: 'rates',
        key: 'rates',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rates - b.rates,
    },
    /*{
        title: 'msg.quotes.rateL4',
        dataIndex: 'rateL4',
        key: 'rateL4',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rateL4 - b.rateL4,
    },*/
    {
        title: 'msg.originSrvFee.currency',
        dataIndex: 'currency',
        key: 'currency',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.currency - b.currency,
    },
    {
        title: 'msg.originSrvFee.uom',
        dataIndex: 'uom',
        key: 'uom',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.uom - b.uom,
    },
    {
        title: 'msg.originSrvFee.legcode',
        dataIndex: 'legcode',
        key: 'legcode',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.legcode - b.legcode,
    }
];
export const agentFeeColumn = [
    /*{
        title: 'msg.agentFee.vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.vendor - b.vendor,
    },
    {
        title: 'msg.agentFee.srvPort',
        dataIndex: 'srvPort',
        key: 'srvPort',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.srvPort - b.srvPort,
    },
    {
        title: 'msg.agentFee.ctnrType',
        dataIndex: 'ctnrType',
        key: 'ctnrType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.ctnrType - b.ctnrType,
    },*/
    {
        title: 'msg.agentFee.chargeDescription',
        dataIndex: 'chargeDescription',
        key: 'chargeDescription',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeDescription - b.chargeDescription,
    },
    {
        title: 'msg.agentFee.chargeType',
        dataIndex: 'chargeType',
        key: 'chargeType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeType - b.chargeType,
    },
    {
        title: 'msg.agentFee.rates',
        dataIndex: 'rates',
        key: 'rates',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rates - b.rates,
    },
    {
        title: 'msg.agentFee.currency',
        dataIndex: 'currency',
        key: 'currency',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.currency - b.currency,
    },
    {
        title: 'msg.agentFee.legcode',
        dataIndex: 'legcode',
        key: 'legcode',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.legcode - b.legcode,
    },
    {
        title: 'msg.agentFee.uom',
        dataIndex: 'uom',
        key: 'uom',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.uom - b.uom,
    },
    /*{
        title: 'msg.agentFee.rctag',
        dataIndex: 'rctag',
        key: 'rctag',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rctag - b.rctag,
    },
    {
        title: 'msg.action.operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
    }*/
];
export const chbColumn = [
    /*{
        title: 'msg.allCHB.vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.vendor - b.vendor,
    },
    {
        title: 'msg.allCHB.srvPort',
        dataIndex: 'srvPort',
        key: 'srvPort',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.srvPort - b.srvPort,
    },
    {
        title: 'msg.allCHB.legcode',
        dataIndex: 'legcode',
        key: 'legcode',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.legcode - b.legcode,
    },*/
    {
        title: 'msg.allCHB.chargeType',
        dataIndex: 'chargeType',
        key: 'chargeType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeType - b.chargeType,
    },
    {
        title: 'msg.allCHB.chargeDescription',
        dataIndex: 'chargeDescription',
        key: 'chargeDescription',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeDescription - b.chargeDescription,
    },
    {
        title: 'msg.allCHB.rates',
        dataIndex: 'rates',
        key: 'rates',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rates - b.rates,
    },
    {
        title: 'msg.allCHB.uom',
        dataIndex: 'uom',
        key: 'uom',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.uom - b.uom,
    },
    {
        title: 'msg.allCHB.currency',
        dataIndex: 'currency',
        key: 'currency',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.currency - b.currency,
    },
    {
        title: 'msg.allCHB.adjust',
        dataIndex: 'adjust',
        key: 'adjust',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.adjust - b.adjust,
    },
    {
        title: 'msg.allCHB.notes',
        dataIndex: 'notes',
        key: 'notes',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.notes - b.notes,
    },
    /*{
        title: 'msg.allCHB.rctag',
        dataIndex: 'rctag',
        key: 'rctag',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rctag - b.rctag,
    },
    {
        title: 'msg.action.operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
    }*/
]
export const draySrvFeeColum = [
    {
        title: 'msg.draySrvFee.legcode',
        dataIndex: 'legcode',
        key: 'legcode',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.legcode - b.legcode,
    },
    {
        title: 'msg.draySrvFee.chargeType',
        dataIndex: 'chargeType',
        key: 'chargeType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeType - b.chargeType,
    },
    {
        title: 'msg.draySrvFee.chargeDescription',
        dataIndex: 'chargeDescription',
        key: 'chargeDescription',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeDescription - b.chargeDescription,
    },
    {
        title: 'msg.draySrvFee.uom',
        dataIndex: 'uom',
        key: 'uom',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.uom - b.uom,
    },
    {
        title: 'msg.draySrvFee.rates',
        dataIndex: 'rates',
        key: 'rates',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rates - b.rates,
    },
    {
        title: 'msg.draySrvFee.adjust',
        dataIndex: 'adjust',
        key: 'adjust',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.adjust - b.adjust,
    },
    {
        title: 'msg.draySrvFee.notes',
        dataIndex: 'notes',
        key: 'notes',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.notes - b.notes,
    },
    /*{
        title: 'msg.draySrvFee.rctag',
        dataIndex: 'rctag',
        key: 'rctag',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rctag - b.rctag,
    },
    {
        title: 'msg.action.operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
    }*/
];
export const warehouseColumn = [
    /*{
        title: 'msg.wareHouse.vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.vendor - b.vendor,
    },
    {
        title: 'msg.wareHouse.srvPort',
        dataIndex: 'srvPort',
        key: 'srvPort',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.srvPort - b.srvPort,
    },*/
    {
        title: 'msg.wareHouse.chargeType',
        dataIndex: 'chargeType',
        key: 'chargeType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeType - b.chargeType,
    },
    {
        title: 'msg.wareHouse.chargeDescription',
        dataIndex: 'chargeDescription',
        key: 'chargeDescription',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeDescription - b.chargeDescription,
    },
    {
        title: 'msg.wareHouse.rateType',
        dataIndex: 'rateType',
        key: 'rateType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rateType - b.rateType,
    },
    /*{
        title: 'msg.wareHouse.ctnrType',
        dataIndex: 'ctnrType',
        key: 'ctnrType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.ctnrType - b.ctnrType,
    },*/
    {
        title: 'msg.wareHouse.uom',
        dataIndex: 'uom',
        key: 'uom',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.uom - b.uom,
    },
    {
        title: 'msg.wareHouse.rates',
        dataIndex: 'rates',
        key: 'rates',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rates - b.rates,
    },
    /*{
        title: 'msg.wareHouse.tieredJson',
        dataIndex: 'tieredJson',
        key: 'tieredJson',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.tieredJson - b.tieredJson,
    },*/
    {
        title: 'msg.wareHouse.currency',
        dataIndex: 'currency',
        key: 'currency',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.currency - b.currency,
    },
    /*{
        title: 'msg.action.operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
    }*/
];
export const expressAHSColumn = [
    {
        title: 'msg.expAHS.chargeDescription',
        dataIndex: 'chargeDescription',
        key: 'chargeDescription',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeDescription - b.chargeDescription,
    },
    {
        title: 'msg.expAHS.zone2',
        dataIndex: 'zone2',
        key: 'zone2',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.zone2 - b.zone2,
    },
    {
        title: 'msg.expAHS.zone3',
        dataIndex: 'zone3',
        key: 'zone3',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.zone3 - b.zone3,
    },
    {
        title: 'msg.expAHS.zone4',
        dataIndex: 'zone4',
        key: 'zone4',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.zone4 - b.zone4,
    },
    {
        title: 'msg.expAHS.zone5',
        dataIndex: 'zone5',
        key: 'zone5',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.zone5 - b.zone5,
    },
    {
        title: 'msg.expAHS.zone6',
        dataIndex: 'zone6',
        key: 'zone6',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.zone6 - b.zone6,
    },
    {
        title: 'msg.expAHS.zone7',
        dataIndex: 'zone7',
        key: 'zone7',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.zone7 - b.zone7,
    },
    {
        title: 'msg.expAHS.zone8',
        dataIndex: 'zone8',
        key: 'zone8',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.zone8 - b.zone8,
    },
    {
        title: 'msg.expAHS.toAk',
        dataIndex: 'toAk',
        key: 'toAk',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.toAk - b.toAk,
    },
    {
        title: 'msg.expAHS.toHi',
        dataIndex: 'toHi',
        key: 'toHi',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.toHi - b.toHi,
    },
    {
        title: 'msg.expAHS.vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.vendor - b.vendor,
    },
    {
        title: 'msg.expAHS.courier',
        dataIndex: 'courier',
        key: 'courier',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.courier - b.courier,
    },
    {
        title: 'msg.expAHS.rctag',
        dataIndex: 'rctag',
        key: 'rctag',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rctag - b.rctag,
    },
    {
        title: 'msg.action.operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
    }
];
export const quotesColumn = [
    {
        title: 'msg.quotes.vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.vendor - b.vendor,
    },
    /*{
        title: 'msg.quotes.legcode',
        dataIndex: 'legcode',
        key: 'legcode',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.legcode - b.legcode,
    },*/
    {
        title: 'msg.quotes.chargeType',
        dataIndex: 'chargeType',
        key: 'chargeType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeType - b.chargeType,
    },
    {
        title: 'msg.quotes.chargeDescription',
        dataIndex: 'chargeDescription',
        key: 'chargeDescription',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.chargeDescription - b.chargeDescription,
    },
    /*{
        title: 'msg.quotes.rateType',
        dataIndex: 'rateType',
        key: 'rateType',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rateType - b.rateType,
    },
    {
        title: 'msg.quotes.rateDetail',
        dataIndex: 'rateDetail',
        key: 'rateDetail',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rateDetail - b.rateDetail,
    },*/
    {
        title: 'msg.quotes.uom',
        dataIndex: 'uom',
        key: 'uom',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.uom - b.uom,
    },
    {
        title: 'msg.quotes.rates',
        dataIndex: 'rates',
        key: 'rates',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rates - b.rates,
    },
    {
        title: 'msg.quotes.rateL4',
        dataIndex: 'rateL4',
        key: 'rateL4',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.rateL4 - b.rateL4,
    },
    /*{
        title: 'msg.quotes.apUnits',
        dataIndex: 'apUnits',
        key: 'apUnits',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.apUnits - b.apUnits,
    },
    {
        title: 'msg.quotes.apValue',
        dataIndex: 'apValue',
        key: 'apValue',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.apValue - b.apValue,
    },*/
    {
        title: 'msg.quotes.arUnits',
        dataIndex: 'arUnits',
        key: 'arUnits',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.arUnits - b.arUnits,
    },
    {
        title: 'msg.quotes.arValue',
        dataIndex: 'arValue',
        key: 'arValue',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.arValue - b.arValue,
    },
    /*{
        title: 'msg.quotes.apInv',
        dataIndex: 'apInv',
        key: 'apInv',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.apInv - b.apInv,
    },
    {
        title: 'msg.quotes.arInv',
        dataIndex: 'arInv',
        key: 'arInv',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.arInv - b.arInv,
    },
    {
        title: 'msg.quotes.apDisp',
        dataIndex: 'apDisp',
        key: 'apDisp',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.apDisp - b.apDisp,
    },
    {
        title: 'msg.quotes.arDisp',
        dataIndex: 'arDisp',
        key: 'arDisp',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.arDisp - b.arDisp,
    },*/
    /*{
        title: 'msg.quotes.legseq',
        dataIndex: 'legseq',
        key: 'legseq',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.legseq - b.legseq,
    },*/
    {
        title: 'msg.quotes.currency',
        dataIndex: 'currency',
        key: 'currency',
        defaultSortOrder: 'ascend',
        sorter: (a, b) => a.currency - b.currency,
    },
    /*{
        title: 'msg.action.operation',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
    }*/
];
export const expBillTemp=
    [
    {RqstID:'TS241031150622278890ST',FromArea:91744,ToZip:33174,Pkgs:1,Length:17,Width:3,Height:3,Weight:7,srvCategory:'FedEx Home Delivery®',deliType:'Residential'},
    {RqstID:'TS241031143917391776ST',FromArea:92337,ToZip:85711,Pkgs:1,Length:43,Width:20,Height:5,Weight:28,srvCategory:'FedEx Home Delivery®',deliType:'Unknown'}
    ];
export const clpInfoTemp=
    [
        {CtnrID:'BEAU2473083',SKU:'ATL-A052-RD-OMTFBA-1',QTY:1,Ctns:184,Length:38,Width:28,Height:8,Weight:8.41,CtnrType:'20GP'},
        {CtnrID:'BEAU2473083',SKU:'BJS-N401-BL-OMTFBA-1',QTY:1,Ctns:652,Length:37,Width:28,Height:8,Weight:7.95,CtnrType:'20GP'},
        {CtnrID:'BEAU2473083',SKU:'BJS-N401-RD-OMTFBA-1',QTY:1,Ctns:550,Length:37,Width:28,Height:8,Weight:8,CtnrType:'20GP'},
        {CtnrID:'BEAU2473083',SKU:'CWB-BL22-00-GWFBA-1',QTY:1,Ctns:1000,Length:34,Width:23.8,Height:6.5,Weight:2.85,CtnrType:'20GP'},
        {CtnrID:'BEAU2473083',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:529,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'20GP'},
        {CtnrID:'BEAU2473083',SKU:'LNS-1CDA-XB-OMTFBA-1',QTY:10,Ctns:91,Length:33,Width:25,Height:39,Weight:12.95,CtnrType:'20GP'},
        {CtnrID:'BEAU2473083',SKU:'MCJ-0000-OG-BNFBA-1',QTY:3,Ctns:33,Length:60,Width:31,Height:47,Weight:20.05,CtnrType:'20GP'},
        {CtnrID:'BMOU6003992',SKU:'AOL-0005-01-BNFBA-1',QTY:15,Ctns:8,Length:45.01,Width:30,Height:43.99,Weight:16.76,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'ASH-1001-CH-BNFBA-1',QTY:9,Ctns:35,Length:57,Width:34.01,Height:57,Weight:15.55,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'ASH-1002-CH-BNFBA-1',QTY:12,Ctns:1,Length:51,Width:50,Height:35,Weight:16.95,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'ASH-1008-BK-BNFBA-1',QTY:8,Ctns:6,Length:43,Width:44,Height:43,Weight:16.1,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'ASH-1008-CH-BNFBA-1',QTY:8,Ctns:8,Length:43,Width:44,Height:43,Weight:15.6,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'BBT-A001-BL-GWFBA-1',QTY:8,Ctns:65,Length:47.5,Width:38,Height:28.5,Weight:8,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'BJS-0010-BL-GWFBA-1',QTY:1,Ctns:1,Length:57.5,Width:34,Height:28,Weight:17.6,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'BJS-ZX01-02-GWFBA-1',QTY:1,Ctns:255,Length:34.01,Width:12.5,Height:26,Weight:5.15,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'BRS-1000-02-PMFBA-1',QTY:15,Ctns:35,Length:62.51,Width:43.51,Height:28.5,Weight:18.85,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'CFS-CF89-16-BNFBA-1',QTY:15,Ctns:27,Length:51.5,Width:21,Height:33.8,Weight:4.15,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'CTS-F0N2-00-GWFBA-1',QTY:20,Ctns:10,Length:23,Width:36,Height:23,Weight:9.5,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'DSS-0007-00-BNFBA-1',QTY:50,Ctns:8,Length:40.01,Width:37.01,Height:26.01,Weight:13.6,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'ETT-0010-BL-OMTFBA-1',QTY:10,Ctns:53,Length:40,Width:28.5,Height:43.5,Weight:10.4,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'ETT-EA88-N1-GWFBA-1',QTY:1,Ctns:256,Length:30,Width:9.3,Height:24,Weight:1.75,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'ETT-F015-RD-FBAOMT-1',QTY:1,Ctns:183,Length:32.5,Width:30,Height:8.2,Weight:2.7,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'FSV-F001-00-GWFBA-1',QTY:50,Ctns:2,Length:60,Width:39,Height:48,Weight:18.4,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'FTK-0010-RD-GWFBA-1',QTY:8,Ctns:79,Length:42,Width:22.5,Height:40.5,Weight:21.35,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'GLS-0000-GR-BNFBA-1',QTY:25,Ctns:32,Length:51.99,Width:27.99,Height:29.01,Weight:8.35,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'HCF-2805-00-BNFBA-1',QTY:1,Ctns:533,Length:30,Width:17.5,Height:16.99,Weight:0.9,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'HMG-8502-U2-BNFBA-1',QTY:8,Ctns:4,Length:46,Width:41,Height:57,Weight:18.8,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'HMG-MGYN-US-BNFBA-1',QTY:1,Ctns:98,Length:26.01,Width:18.01,Height:18.01,Weight:2.21,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'HRS-0011-GN-FBABN-1',QTY:10,Ctns:70,Length:48.01,Width:32,Height:38,Weight:13.14,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'IPV-F0T1-00-OMTFBA-1',QTY:50,Ctns:5,Length:35.5,Width:12,Height:25,Weight:6.41,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'LNS-4MGA-5S-OMTFBA-1',QTY:10,Ctns:51,Length:32.5,Width:37.5,Height:24,Weight:17.35,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'LNS-6CAB-6S-OMTFBA-1',QTY:10,Ctns:73,Length:32.5,Width:37.5,Height:24,Weight:8.2,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'LNS-6CEA-6S-OMTFBA-1',QTY:10,Ctns:2,Length:33,Width:38,Height:25,Weight:15.85,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'LNS-6CJD-6S-OMTFBA-1',QTY:10,Ctns:28,Length:33,Width:39,Height:25,Weight:17.2,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'MAS-K230-00-BNFBA-1',QTY:12,Ctns:46,Length:50,Width:26,Height:27,Weight:18,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'MDK-0001-00-GWFBA-1',QTY:1,Ctns:2749,Length:31,Width:8.2,Height:24,Weight:1.3,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'PTL-1306-NI-BNFBA-1',QTY:1,Ctns:211,Length:18.5,Width:29,Height:18.5,Weight:0.8,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'WAS-0008-2S-GWFBA-1',QTY:1,Ctns:206,Length:40.01,Width:16.99,Height:23,Weight:7.45,CtnrType:'40HQ'},
        {CtnrID:'BMOU6003992',SKU:'WAS-4138-12-OMTFBA-1',QTY:1,Ctns:328,Length:30.5,Width:19,Height:17.5,Weight:6.17,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'CWB-BL22-00-GWFBA-1',QTY:1,Ctns:500,Length:34,Width:23.8,Height:6.5,Weight:2.85,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:350,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'DMG-5FTY-RE-GWFBA-1',QTY:5,Ctns:88,Length:52,Width:36,Height:26,Weight:12.2,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'JWQ-BMW1-01-GWFBA-1',QTY:30,Ctns:15,Length:57,Width:30,Height:47,Weight:16.9,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'KNC-H51A-BK-BNFBA-1',QTY:20,Ctns:15,Length:27,Width:35,Height:21,Weight:6,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'KNC-LSL2-GR-BNFBA-1',QTY:50,Ctns:11,Length:41,Width:38,Height:20,Weight:4.15,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'OTP-8011-00-GWFBA-1',QTY:5,Ctns:36,Length:50.5,Width:25,Height:33.7,Weight:19.1,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'QTB-0000-BK-HRMFBA-1',QTY:50,Ctns:4,Length:50.01,Width:33,Height:34.01,Weight:8.25,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'RGS-0000-00-BNFBA-1',QTY:25,Ctns:27,Length:45.01,Width:19,Height:41,Weight:11.25,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'RLB-0000-00-BNFBA-1',QTY:100,Ctns:28,Length:49,Width:27,Height:45.01,Weight:13.6,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'RLS-0007-01-BNFBA-1',QTY:100,Ctns:5,Length:45.01,Width:19.99,Height:41,Weight:6.15,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SCO-0001-02-BNFBA-1',QTY:60,Ctns:7,Length:43.5,Width:44.5,Height:38.5,Weight:16.6,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SDB-2019-35-BNFBA-1',QTY:50,Ctns:8,Length:34.5,Width:28.5,Height:24.5,Weight:10.9,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SDB-2019-LX-BNFBA-1',QTY:8,Ctns:74,Length:30.5,Width:18,Height:22,Weight:4.8,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SDC-0012-BK-FBABN-1',QTY:6,Ctns:115,Length:57.5,Width:44.8,Height:38,Weight:13.3,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SRS-8586-00-FBABN-1',QTY:8,Ctns:5,Length:55,Width:37,Height:33,Weight:20.92,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SRS-D858-00-BNFBA-1',QTY:12,Ctns:93,Length:54.5,Width:37,Height:49,Weight:19.05,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'STG-ZJMJ-2P-BNFBA-1',QTY:25,Ctns:11,Length:42.5,Width:42,Height:25,Weight:13.15,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SVA-L001-BE-OMTFBA-1',QTY:20,Ctns:5,Length:59,Width:44,Height:43,Weight:14.25,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SVA-LW01-GY-OMTFBA-1',QTY:20,Ctns:4,Length:58.5,Width:43.5,Height:41.5,Weight:14.75,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'SWC-FRGG-BL-BNFBA-1',QTY:10,Ctns:16,Length:60.5,Width:44.5,Height:36,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'TAD-M040-00-OMTFBA-1',QTY:10,Ctns:46,Length:36,Width:45,Height:33,Weight:16,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'TRE-J2M0-2H-BNFBA-1',QTY:4,Ctns:22,Length:62.5,Width:41,Height:33.5,Weight:12.9,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'TRK-0131-2Y-BNFBA-1',QTY:5,Ctns:240,Length:40.5,Width:22,Height:31.5,Weight:10.8,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'WFL-5G5D-AK-OMTFBA-1',QTY:2,Ctns:31,Length:36,Width:20,Height:14,Weight:4.45,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'WFL-5G5D-AL-GWFBA-1',QTY:2,Ctns:31,Length:36,Width:20,Height:14,Weight:4.45,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'WSM-SD25-01-BNFBA-1',QTY:1,Ctns:494,Length:37.49,Width:18,Height:19,Weight:5.55,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'XQD-4328-50-BNFBA-1',QTY:20,Ctns:16,Length:45,Width:30.5,Height:14,Weight:6.96,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'XST-7331-A1-BNFBA-1',QTY:5,Ctns:46,Length:33.5,Width:33.5,Height:44,Weight:14.8,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'XST-7341-S1-BNFBA-1',QTY:5,Ctns:26,Length:35,Width:40.5,Height:47,Weight:21.32,CtnrType:'40HQ'},
        {CtnrID:'BMOU6340020',SKU:'YSS-N000-PL-BNFBA-1',QTY:8,Ctns:76,Length:54.5,Width:31.5,Height:40,Weight:21.55,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'APF-KZ01-01-BNFBA-1',QTY:24,Ctns:18,Length:47.5,Width:58.3,Height:25.5,Weight:19.4,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'BDH-0027-BK-BNFBA-1',QTY:10,Ctns:10,Length:50,Width:38.8,Height:29,Weight:12.4,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'BDH-0027-WH-BNFBA-1',QTY:10,Ctns:11,Length:50,Width:38.8,Height:29,Weight:12.4,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'BHG-012A-00-HZFBA-1',QTY:30,Ctns:13,Length:62.5,Width:61,Height:50,Weight:16.7,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'BJS-0014-00-OMTFBA-1',QTY:1,Ctns:821,Length:37,Width:32,Height:11,Weight:5.85,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'CWB-GS08-RD-GWFBA-1',QTY:1,Ctns:115,Length:33,Width:27,Height:9.5,Weight:1.9,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'DAH-HU5K-12-FBAGW-1',QTY:1,Ctns:76,Length:47.5,Width:29,Height:45,Weight:7.7,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'DVF-PL04-US-QLFBA-1',QTY:8,Ctns:50,Length:42,Width:41,Height:37,Weight:9,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'EID-HS12-US-BNUSFBA-1',QTY:1,Ctns:76,Length:38,Width:24.99,Height:16.51,Weight:1.6,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'ETT-AV30-RD-OMTFBA-1',QTY:1,Ctns:110,Length:33,Width:10,Height:30,Weight:3.55,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'GSQ-0009-00-OMTFBA-1',QTY:1,Ctns:500,Length:45,Width:32,Height:12,Weight:3.4,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'HCF-1313-BN-BNFBA-1',QTY:1,Ctns:297,Length:36,Width:36,Height:18,Weight:1.6,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'KNC-HD41-BK-GPUFBA-1',QTY:20,Ctns:1,Length:36,Width:27,Height:22,Weight:7.6,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'KNC-LSCL-GN-BNFBA-1',QTY:50,Ctns:5,Length:19.5,Width:41.5,Height:38,Weight:7.9,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'KNC-LSL9-GN-BNFBA-1',QTY:50,Ctns:5,Length:20,Width:40,Height:36,Weight:4.2,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'NET-JW02-00-GWFBA-1',QTY:8,Ctns:6,Length:49,Width:30.5,Height:49,Weight:7.15,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'NSS-E005-00-GWFBA-1',QTY:1,Ctns:100,Length:32.5,Width:25.7,Height:8.7,Weight:2,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'OAP-0002-US-QLFBA-1',QTY:30,Ctns:11,Length:57,Width:48,Height:29,Weight:12.4,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'ORK-G150-00-BNFBA-1',QTY:20,Ctns:13,Length:48.5,Width:25,Height:20.5,Weight:5.9,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'PAP-0006-RD-GWFBA-1',QTY:4,Ctns:261,Length:38,Width:35,Height:30.5,Weight:20,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'PGB-5GAL-5G-QLFBA-1',QTY:25,Ctns:8,Length:50,Width:40,Height:48,Weight:15.59,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'SCK-0001-BL-GWFBA-1',QTY:5,Ctns:41,Length:38,Width:31,Height:23,Weight:11.36,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'SDB-2019-05-BNFBA-1',QTY:30,Ctns:40,Length:40,Width:35,Height:27,Weight:15.3,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'SDB-2019-TA-BNFBA-1',QTY:25,Ctns:8,Length:28,Width:25,Height:36.5,Weight:18.25,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'SPS-1250-BK-BNFBA-1',QTY:20,Ctns:14,Length:52.5,Width:38.5,Height:20,Weight:10.56,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'SRS-D858-00-BNFBA-1',QTY:12,Ctns:14,Length:54.5,Width:37,Height:49,Weight:19.05,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'TBI-DG01-00-OMTFBA-1',QTY:100,Ctns:2,Length:41,Width:36,Height:28,Weight:9.05,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'TEK-N007-01-BNFBA-1',QTY:1,Ctns:215,Length:48,Width:31,Height:10,Weight:4.4,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'UVC-GLJM-02-BNFBA-1',QTY:50,Ctns:3,Length:52.5,Width:40.5,Height:31.5,Weight:11.5,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'WOS-VW01-N0-OMTFBA-1',QTY:24,Ctns:6,Length:50,Width:47,Height:56,Weight:16.1,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'YSS-N001-BK-BNFBA-1',QTY:8,Ctns:22,Length:55,Width:32,Height:40,Weight:20.8,CtnrType:'40HQ'},
        {CtnrID:'CAIU4794765',SKU:'YSS-N001-BL-BNFBA-1',QTY:8,Ctns:16,Length:54,Width:31.5,Height:40,Weight:21.2,CtnrType:'40HQ'},
        {CtnrID:'CAIU6345995',SKU:'BJS-N401-BK-OMTFBA-1',QTY:1,Ctns:110,Length:37.5,Width:28,Height:8,Weight:7.85,CtnrType:'20GP'},
        {CtnrID:'CAIU6345995',SKU:'BJS-N401-RD-OMTFBA-1',QTY:1,Ctns:994,Length:37,Width:28,Height:8,Weight:8,CtnrType:'20GP'},
        {CtnrID:'CAIU6345995',SKU:'CFS-CF89-08-BNFBA-1',QTY:15,Ctns:72,Length:58,Width:19.5,Height:14,Weight:2,CtnrType:'20GP'},
        {CtnrID:'CAIU6345995',SKU:'CFS-CF89-16-BNFBA-1',QTY:15,Ctns:9,Length:51.5,Width:33.8,Height:21,Weight:4.15,CtnrType:'20GP'},
        {CtnrID:'CAIU6345995',SKU:'CWB-0003-BL-GWFBA-1',QTY:10,Ctns:30,Length:32.5,Width:43,Height:18.5,Weight:14.15,CtnrType:'20GP'},
        {CtnrID:'CAIU6345995',SKU:'CWB-BL22-00-GWFBA-1',QTY:1,Ctns:1601,Length:34,Width:23.8,Height:6.5,Weight:2.85,CtnrType:'20GP'},
        {CtnrID:'CAIU6345995',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:1197,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'20GP'},
        {CtnrID:'CAIU6463196',SKU:'ATL-A052-RD-OMTFBA-1',QTY:1,Ctns:398,Length:38,Width:28,Height:8,Weight:8.41,CtnrType:'20GP'},
        {CtnrID:'CAIU6463196',SKU:'BJS-D004-00-FBAOMT-1',QTY:12,Ctns:22,Length:36,Width:33,Height:24,Weight:17.9,CtnrType:'20GP'},
        {CtnrID:'CAIU6463196',SKU:'BJS-N401-BK-OMTFBA-1',QTY:1,Ctns:199,Length:37.5,Width:28,Height:8,Weight:7.85,CtnrType:'20GP'},
        {CtnrID:'CAIU6463196',SKU:'BSK-0014-RD-GWFBA-1',QTY:4,Ctns:62,Length:41,Width:31.5,Height:28.5,Weight:22.2,CtnrType:'20GP'},
        {CtnrID:'CAIU6463196',SKU:'CWB-BL22-00-GWFBA-1',QTY:1,Ctns:3000,Length:34,Width:23.8,Height:6.5,Weight:2.85,CtnrType:'20GP'},
        {CtnrID:'CAIU6463196',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:1000,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'20GP'},
        {CtnrID:'FCIU9962638',SKU:'AOL-0005-01-BNFBA-1',QTY:15,Ctns:8,Length:45.01,Width:43.99,Height:30,Weight:16.76,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'AZK-FWS1-04-GWFBA-1',QTY:50,Ctns:6,Length:57,Width:27,Height:33,Weight:13.25,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'BDS-0001-01-GWFBA-1',QTY:100,Ctns:10,Length:44,Width:27,Height:35,Weight:13.9,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'BIP-00TX-69-BNFBA-1',QTY:50,Ctns:4,Length:45,Width:40.5,Height:35.5,Weight:19.5,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'BIP-MOUN-69-BNFBA-1',QTY:50,Ctns:6,Length:48,Width:40.5,Height:33,Weight:20.77,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'BJS-0010-00-OMTFBA-1',QTY:10,Ctns:109,Length:57.5,Width:28,Height:34,Weight:17.9,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'BJS-ZX01-02-GWFBA-1',QTY:1,Ctns:88,Length:34.01,Width:26,Height:12.5,Weight:5.15,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'BRS-0800-02-PMFBA-1',QTY:15,Ctns:7,Length:62.51,Width:28.5,Height:43.51,Weight:16.2,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'BTC-S002-00-OMTFBA-1',QTY:50,Ctns:3,Length:52,Width:51,Height:33,Weight:18.9,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'DSS-0002-00-BNFBA-1',QTY:50,Ctns:3,Length:40.01,Width:26.01,Height:37.01,Weight:14.15,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'E1A-W1CK-US-SWFBA-1',QTY:12,Ctns:1,Length:54,Width:29.5,Height:61,Weight:13.76,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'E1A-W1QU-US-SWFBA-1',QTY:12,Ctns:3,Length:54,Width:30.5,Height:53,Weight:12.15,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'E1B-W1CK-US-SWFBA-1',QTY:6,Ctns:16,Length:54,Width:29.5,Height:39,Weight:11.65,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'E1B-W1TW-US-SWFBA-1',QTY:10,Ctns:21,Length:54,Width:29.5,Height:39,Weight:11.55,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'EDF-0028-01-BNFBA-1',QTY:24,Ctns:4,Length:53.01,Width:27,Height:32,Weight:10.2,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'ETT-0010-BL-OMTFBA-1',QTY:10,Ctns:42,Length:40,Width:43.5,Height:28.5,Weight:10.4,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'ETT-0010-RD-OMTFBA-1',QTY:10,Ctns:12,Length:40,Width:43,Height:28.5,Weight:10.4,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'ETT-F002-00-OMTFBA-1',QTY:20,Ctns:9,Length:40,Width:32,Height:11,Weight:4,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'ETT-F009-00-OMTFBA-1',QTY:1,Ctns:5,Length:29,Width:9.5,Height:24,Weight:1.7,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'ETT-NN07-BL-OMTFBA-1',QTY:10,Ctns:12,Length:49,Width:33,Height:46,Weight:19.6,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'EWP-0001-01-GWFBA-1',QTY:12,Ctns:32,Length:40,Width:30,Height:28,Weight:8.05,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'FHL-F002-01-GWFBA-1',QTY:12,Ctns:10,Length:27,Width:25,Height:39,Weight:12.35,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'FHL-F002-N2-GWFBA-1',QTY:6,Ctns:18,Length:42,Width:26,Height:27.5,Weight:12.25,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'GEK-XCD0-70-BILIFBA-1',QTY:11,Ctns:2,Length:44,Width:43,Height:24,Weight:12.39,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'GMP-LS02-UP-BNFBA-1',QTY:4,Ctns:100,Length:39,Width:40,Height:23,Weight:13.5,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'GMR-2020-BK-ZLSFBA-1',QTY:10,Ctns:42,Length:51,Width:35,Height:27,Weight:15.2,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'GSQ-0009-00-OMTFBA-1',QTY:1,Ctns:300,Length:45,Width:32,Height:11,Weight:3.55,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'HCF-1313-BZ-BNFBA-1',QTY:1,Ctns:70,Length:36,Width:36,Height:18,Weight:1.6,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'HCF-1722-00-BNFBA-1',QTY:1,Ctns:472,Length:34,Width:28,Height:19.51,Weight:1.5,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'HMG-JJ01-U2-BNFBA-1',QTY:1,Ctns:220,Length:45,Width:17.5,Height:34,Weight:7.75,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'HRS-0002-00-BNFBA-1',QTY:25,Ctns:16,Length:45,Width:41,Height:41,Weight:21.5,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'HRS-0005-G5-FBA-1',QTY:10,Ctns:27,Length:48.01,Width:38,Height:30.99,Weight:13.56,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'IPV-F003-00-GGWFBA-1',QTY:50,Ctns:2,Length:32,Width:32,Height:10,Weight:4.85,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'IST-A001-00-OMTFBA-1',QTY:1,Ctns:100,Length:27.99,Width:11.99,Height:11,Weight:1.6,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'JJD-0308-US-BNFBA-1',QTY:20,Ctns:8,Length:32,Width:27,Height:24,Weight:7.74,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'KSH-S002-01-OMTFBA-1',QTY:50,Ctns:17,Length:52,Width:31.5,Height:37.5,Weight:18.5,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'LNS-1CAB-5S-OMTFBA-1',QTY:10,Ctns:64,Length:33,Width:25,Height:38,Weight:7.65,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'LNS-1CDD-XB-OMTFBA-1',QTY:10,Ctns:34,Length:32.5,Width:25,Height:39,Weight:10.7,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'LNS-3CFD-4B-OMTFBA-1',QTY:10,Ctns:43,Length:32.5,Width:25,Height:38.5,Weight:9.8,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'LPF-N000-ST-GWFBA-1',QTY:30,Ctns:17,Length:50,Width:36,Height:37,Weight:11.1,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'LPF-N0PK-00-GWFBA-1',QTY:30,Ctns:34,Length:50,Width:36,Height:37.5,Weight:13.2,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'MCJ-0000-BK-BNFBA-1',QTY:3,Ctns:8,Length:61,Width:32,Height:47,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'MCJ-0000-GY-BNFBA-1',QTY:3,Ctns:48,Length:60.5,Width:31.5,Height:47.5,Weight:20,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'MCJ-0000-RD-BNFBA-1',QTY:3,Ctns:18,Length:61,Width:32,Height:47,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'MDK-0001-BL-GWFBA-1',QTY:1,Ctns:497,Length:30.99,Width:8.5,Height:23.5,Weight:1.2,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'MON-30MM-BK-GPUFBA-1',QTY:40,Ctns:11,Length:45,Width:40,Height:31,Weight:14.35,CtnrType:'40HQ'},
        {CtnrID:'FCIU9962638',SKU:'MON-N006-00-FBABN-1',QTY:50,Ctns:20,Length:35,Width:18,Height:31,Weight:7.6,CtnrType:'40HQ'},
        {CtnrID:'GCXU2286072',SKU:'BJS-0010-BK-GWFBA-1',QTY:10,Ctns:162,Length:57.5,Width:28,Height:34,Weight:17.6,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'BJS-N401-BK-OMTFBA-1',QTY:1,Ctns:300,Length:37.5,Width:28,Height:8,Weight:7.85,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'BJS-N401-RD-OMTFBA-1',QTY:1,Ctns:500,Length:37,Width:28,Height:8,Weight:8,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'CRR-F001-00-GWFBA-1',QTY:100,Ctns:3,Length:35.5,Width:23,Height:11.5,Weight:7.9,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'LNS-6CLF-6S-OMTFBA-1',QTY:4,Ctns:119,Length:34,Width:29,Height:15,Weight:12.75,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'LNS-6CLF-8B-OMTFBA-1',QTY:4,Ctns:116,Length:44.5,Width:30,Height:15,Weight:16.9,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'LNS-6CLF-8S-OMTFBA-1',QTY:4,Ctns:19,Length:45,Width:30,Height:15,Weight:17.1,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'MTB-2020-SJ-PMFBA-1',QTY:3,Ctns:3,Length:34.5,Width:27,Height:62,Weight:16.2,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'PAP-0006-BL-OMTFBA-1',QTY:4,Ctns:165,Length:38,Width:35,Height:30.99,Weight:19.8,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'PAP-0006-BS-GWFBA-1',QTY:4,Ctns:14,Length:38,Width:35,Height:30,Weight:19.95,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'PAP-0006-RB-GWFBA-1',QTY:4,Ctns:14,Length:38,Width:34,Height:30,Weight:19.95,CtnrType:'20GP'},
        {CtnrID:'GCXU2286072',SKU:'SDS-2020-AP-BNFBA-1',QTY:15,Ctns:1,Length:28,Width:26,Height:18,Weight:9.21,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'ATL-0052-BL-GWFBA-1',QTY:1,Ctns:42,Length:37,Width:33,Height:10,Weight:8.32,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'ATL-A052-RD-OMTFBA-1',QTY:1,Ctns:148,Length:38,Width:28,Height:8,Weight:8.41,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'BJS-N401-BL-OMTFBA-1',QTY:1,Ctns:235,Length:37,Width:28,Height:8,Weight:7.95,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'BSK-0014-RD-GWFBA-1',QTY:4,Ctns:130,Length:40,Width:30.5,Height:27.5,Weight:22.2,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'BSN-S036-RD-BNFBA-1',QTY:4,Ctns:300,Length:32.5,Width:24.5,Height:19.96,Weight:11.9,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'BSN-S036-RZ-BDDFBA-1',QTY:4,Ctns:33,Length:32,Width:25,Height:21,Weight:12,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:300,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'JJD-0308-US-BNFBA-1',QTY:20,Ctns:4,Length:32,Width:27,Height:24,Weight:7.74,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'OMS-201G-BK-BNFBA-1',QTY:20,Ctns:1,Length:43,Width:29.01,Height:41,Weight:17.25,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'PTL-1306-BK-BNFBA-1',QTY:1,Ctns:93,Length:18.5,Width:18.5,Height:28.5,Weight:0.82,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'SCK-0001-00-FBAOMT-1',QTY:5,Ctns:200,Length:38,Width:31,Height:23,Weight:11.36,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'SCK-0001-BL-GWFBA-1',QTY:5,Ctns:24,Length:38,Width:31,Height:23,Weight:11.36,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'SCO-0001-02-BNFBA-1',QTY:60,Ctns:10,Length:43.5,Width:44.5,Height:38.5,Weight:16.6,CtnrType:'20GP'},
        {CtnrID:'NYKU3220564',SKU:'WAS-1506-B2-GWFBA-1',QTY:1,Ctns:400,Length:40,Width:23,Height:14.5,Weight:8.03,CtnrType:'20GP'},
        {CtnrID:'NYKU4414970',SKU:'ATM-06BK-FL-PMFBA-1',QTY:2,Ctns:1,Length:56,Width:40,Height:39,Weight:18.3,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ATM-Y000-01-PMFBA-1',QTY:1,Ctns:42,Length:53,Width:29,Height:23,Weight:7.2,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ATM-Y000-02-PMFBA-1',QTY:1,Ctns:7,Length:53,Width:29,Height:23,Weight:7.2,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ATM-Y000-03-PMFBA-1',QTY:1,Ctns:36,Length:53,Width:29,Height:23,Weight:4.8,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ATM-Y000-04-PMFBA-1',QTY:1,Ctns:15,Length:53,Width:29,Height:23,Weight:4.8,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ATM-Y000-07-PMFBA-1',QTY:1,Ctns:20,Length:35,Width:19,Height:23,Weight:7.5,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ATM-Y000-10-PMFBA-1',QTY:1,Ctns:15,Length:53,Width:29,Height:37,Weight:16,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ATM-Y000-11-PMFBA-1',QTY:1,Ctns:6,Length:53,Width:29,Height:23,Weight:9.6,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'BDS-0002-00-GWFBA-1',QTY:50,Ctns:6,Length:42,Width:22,Height:28,Weight:13.8,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'BRS-0500-02-PMFBA-1',QTY:15,Ctns:3,Length:62.51,Width:28.5,Height:43,Weight:11.4,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'BRS-1000-02-PMFBA-1',QTY:15,Ctns:5,Length:62.51,Width:28.5,Height:43.51,Weight:18.85,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'BRS-1200-02-PMFBA-1',QTY:15,Ctns:18,Length:62,Width:29.01,Height:43,Weight:22.02,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'DKK-XCD1-60-BILIFBA-1',QTY:20,Ctns:9,Length:47,Width:42,Height:24,Weight:13.5,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'DSS-0T1L-BK-BNFBA-1',QTY:20,Ctns:58,Length:35,Width:27.5,Height:22,Weight:5.7,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ETT-0010-BL-OMTFBA-1',QTY:10,Ctns:10,Length:40,Width:43.5,Height:28.5,Weight:10.4,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ETT-EA88-N1-GWFBA-1',QTY:1,Ctns:78,Length:30,Width:24,Height:9.3,Weight:1.75,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'ETT-F015-RD-FBAOMT-1',QTY:1,Ctns:50,Length:32.5,Width:8.2,Height:30,Weight:2.7,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'FBT-DBP1-00-BNFBA-1',QTY:4,Ctns:314,Length:51,Width:35.5,Height:37,Weight:14.41,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'MDK-0001-00-GWFBA-1',QTY:1,Ctns:787,Length:31,Width:24,Height:8.2,Weight:1.3,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'MDK-0001-BL-GWFBA-1',QTY:1,Ctns:401,Length:30.99,Width:8.5,Height:23.5,Weight:1.2,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'MTB-2020-GN-PMFBA-1',QTY:6,Ctns:17,Length:56.5,Width:24.5,Height:51.5,Weight:19.55,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'MTB-2020-MM-PMFBA-1',QTY:4,Ctns:6,Length:52,Width:42,Height:31,Weight:19.65,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'NET-0406-00-OMTFBA-1',QTY:15,Ctns:72,Length:56,Width:37,Height:28,Weight:22.15,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'PTL-1719-00-BNFBA-1',QTY:1,Ctns:108,Length:43.5,Width:33,Height:22,Weight:5.6,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'RWH-0006-00-GWFBA-1',QTY:8,Ctns:54,Length:48.5,Width:36,Height:25,Weight:15.65,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'SCK-0001-BL-GWFBA-1',QTY:5,Ctns:30,Length:38,Width:31,Height:23,Weight:11.36,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'SCO-0001-02-BNFBA-1',QTY:60,Ctns:1,Length:43.5,Width:44.5,Height:38.5,Weight:16.6,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'SDB-2019-05-BNFBA-1',QTY:30,Ctns:130,Length:40,Width:35,Height:27,Weight:15.3,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'SDB-2019-35-BNFBA-1',QTY:50,Ctns:9,Length:34.5,Width:28.5,Height:24.5,Weight:10.9,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'SDB-2019-CO-BNFBA-1',QTY:50,Ctns:4,Length:34.5,Width:29,Height:23.5,Weight:8.6,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'SDS-2020-06-BNFBA-1',QTY:5,Ctns:60,Length:27,Width:23,Height:10,Weight:8.5,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'SGO-11AC-US-BNFBA-1',QTY:1,Ctns:18,Length:18,Width:12.5,Height:8,Weight:0.5,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'TAD-SM80-N0-OMTFBA-1',QTY:6,Ctns:47,Length:44.5,Width:37,Height:32,Weight:19.12,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'TRK-0131-2Y-BNFBA-1',QTY:5,Ctns:23,Length:41,Width:22,Height:32,Weight:11.75,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'UVC-GLJM-02-BNFBA-1',QTY:50,Ctns:2,Length:52.5,Width:40.5,Height:31.5,Weight:11.5,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'VBT-BALL-4C-PMFBA-1',QTY:44,Ctns:7,Length:58,Width:35,Height:29,Weight:21.6,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'WAS-0008-2S-GWFBA-1',QTY:1,Ctns:138,Length:40.01,Width:23,Height:16.99,Weight:7.45,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'WAS-0012-2S-GWFBA-1',QTY:1,Ctns:109,Length:40,Width:23,Height:14,Weight:7.06,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'WAS-0020-2S-GWFBA-1',QTY:1,Ctns:30,Length:45,Width:25.8,Height:16.5,Weight:9.05,CtnrType:'40HQ'},
        {CtnrID:'NYKU4414970',SKU:'WAS-4138-12-OMTFBA-1',QTY:1,Ctns:124,Length:30,Width:19,Height:19,Weight:6.16,CtnrType:'40HQ'},
        {CtnrID:'NYKU9830374',SKU:'BJS-N401-BK-OMTFBA-1',QTY:1,Ctns:459,Length:37.5,Width:28,Height:8,Weight:7.85,CtnrType:'20GP'},
        {CtnrID:'NYKU9830374',SKU:'BJS-N401-BL-OMTFBA-1',QTY:1,Ctns:564,Length:37,Width:28,Height:8,Weight:7.95,CtnrType:'20GP'},
        {CtnrID:'NYKU9830374',SKU:'BJS-N401-RD-OMTFBA-1',QTY:1,Ctns:550,Length:37,Width:28,Height:8,Weight:8,CtnrType:'20GP'},
        {CtnrID:'NYKU9830374',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:1738,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'20GP'},
        {CtnrID:'NYKU9830374',SKU:'D6A-W1ST-US-SWFBA-1',QTY:4,Ctns:46,Length:55,Width:35,Height:45.5,Weight:6.65,CtnrType:'20GP'},
        {CtnrID:'SEGU4043186',SKU:'CWB-BL22-00-GWFBA-1',QTY:1,Ctns:3339,Length:34,Width:23.8,Height:6.5,Weight:2.85,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:1688,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'MFK-2019-BU-FBAOMT-1',QTY:10,Ctns:15,Length:47.5,Width:32,Height:33,Weight:10.25,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'MTB-2020-MM-PMFBA-1',QTY:4,Ctns:19,Length:52,Width:43,Height:31,Weight:19.67,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'PTL-1616-11-BNFBA-1',QTY:1,Ctns:92,Length:35.99,Width:19.99,Height:34.01,Weight:2,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'PTW-CTT3-01-BNFBA-1',QTY:50,Ctns:24,Length:57,Width:58,Height:32,Weight:17.27,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'QCW-0175-04-GWFBA-1',QTY:25,Ctns:1,Length:47,Width:47,Height:27,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'SDC-N008-BK-BNFBA-1',QTY:10,Ctns:267,Length:57,Width:55,Height:38,Weight:12.55,CtnrType:'40HQ'},
        {CtnrID:'SEGU4043186',SKU:'TAD-SM80-N0-OMTFBA-1',QTY:6,Ctns:50,Length:44.5,Width:37,Height:32,Weight:19.12,CtnrType:'40HQ'},
        {CtnrID:'SMCU2000130',SKU:'BSN-S012-R1-BNFBA-1',QTY:2,Ctns:425,Length:31.5,Width:24,Height:22.5,Weight:11.85,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'LNS-5MGA-6B-GWFBA-1',QTY:10,Ctns:103,Length:33,Width:25,Height:38,Weight:20.65,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'LNS-6CJD-8S-GWFBA-1',QTY:5,Ctns:136,Length:32.5,Width:21.5,Height:20,Weight:10.55,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'LNS-6CLF-8S-OMTFBA-1',QTY:4,Ctns:56,Length:45,Width:30,Height:15,Weight:17.1,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'PAP-0006-RB-GWFBA-1',QTY:4,Ctns:97,Length:38,Width:34,Height:30,Weight:19.95,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'QCA-134A-09-GWFBA-1',QTY:20,Ctns:31,Length:30.5,Width:25.5,Height:19.5,Weight:11.25,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'QCA-2020-00-GWFBA-1',QTY:35,Ctns:11,Length:29,Width:25.5,Height:20,Weight:12.16,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'SCS-N300-00-GWFBA-1',QTY:5,Ctns:241,Length:39,Width:16.5,Height:36.5,Weight:16.35,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'SDB-2019-05-BNFBA-1',QTY:30,Ctns:99,Length:40,Width:35,Height:27,Weight:15.3,CtnrType:'20GP'},
        {CtnrID:'SMCU2000130',SKU:'SDB-2019-06-BNFBA-1',QTY:8,Ctns:15,Length:31,Width:18,Height:22,Weight:4.65,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'BJS-N401-BL-OMTFBA-1',QTY:1,Ctns:300,Length:37,Width:28,Height:8,Weight:7.95,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'BSN-S036-RZ-BDDFBA-1',QTY:4,Ctns:6,Length:32,Width:25,Height:21,Weight:11.59,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'FWV-1200-GY-ZLSFBA-1',QTY:1,Ctns:400,Length:27,Width:24.99,Height:8.99,Weight:5.72,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'SCK-0001-BL-GWFBA-1',QTY:5,Ctns:23,Length:38,Width:31,Height:23,Weight:10.5,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'SCS-N300-SL-GWFBA-1',QTY:5,Ctns:87,Length:39,Width:16.5,Height:37,Weight:16.31,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'SDB-2019-35-BNFBA-1',QTY:50,Ctns:5,Length:34.5,Width:28.5,Height:24.5,Weight:9.98,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'SDB-2019-TA-BNFBA-1',QTY:25,Ctns:4,Length:28,Width:25,Height:36.5,Weight:17.46,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'SDC-0012-BK-FBABN-1',QTY:6,Ctns:58,Length:57.5,Width:44.8,Height:38,Weight:12.3,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'SDS-2020-06-BNFBA-1',QTY:5,Ctns:316,Length:27,Width:23,Height:10,Weight:8.5,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'SGO-0000-02-BNSLF-1',QTY:145,Ctns:1,Length:32.5,Width:32,Height:13,Weight:7.23,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'TAS-0204-N0-FBAOMT-1',QTY:18,Ctns:107,Length:57.5,Width:25,Height:13.5,Weight:9.88,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'TRK-K262-SM-BNFBA-1',QTY:1,Ctns:83,Length:40,Width:20.5,Height:9.5,Weight:4.55,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'TRK-S131-00-BNFBA-1',QTY:5,Ctns:40,Length:41,Width:22,Height:31,Weight:11.75,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'UBS-T001-00-GWFBA-1',QTY:1,Ctns:117,Length:31,Width:26,Height:8,Weight:6.81,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'WCR-HR08-00-GWFBA-1',QTY:1,Ctns:259,Length:28,Width:26,Height:9,Weight:6.8,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'WFL-4E8I-CL-GWFBA-1',QTY:1,Ctns:154,Length:36,Width:20,Height:15.5,Weight:7.45,CtnrType:'20GP'},
        {CtnrID:'SMCU2029431',SKU:'WSM-SD25-01-BNFBA-1',QTY:1,Ctns:308,Length:37.49,Width:18,Height:19,Weight:5.55,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'BJS-N401-RD-OMTFBA-1',QTY:1,Ctns:1350,Length:37,Width:28,Height:8,Weight:8,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'GEK-NPUD-05-BILIFBA-1',QTY:20,Ctns:6,Length:39,Width:33,Height:37,Weight:14.07,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'HMG-8502-U2-BNFBA-1',QTY:8,Ctns:15,Length:46,Width:57,Height:41,Weight:18.8,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'LNS-5MGA-5S-OMTFBA-1',QTY:10,Ctns:55,Length:33,Width:25,Height:39,Weight:17.45,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'LNS-6CEA-6S-OMTFBA-1',QTY:10,Ctns:9,Length:33,Width:25,Height:38,Weight:15.85,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'LNS-6CJD-6B-GWFBA-1',QTY:10,Ctns:83,Length:33,Width:25,Height:39,Weight:17.1,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'LNS-6CJD-6S-OMTFBA-1',QTY:10,Ctns:4,Length:33,Width:25,Height:39,Weight:17.2,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'LNS-6CLC-6B-OMTFBA-1',QTY:4,Ctns:150,Length:34,Width:30,Height:15,Weight:13.8,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'MDK-0001-BL-GWFBA-1',QTY:1,Ctns:1023,Length:30.99,Width:8.5,Height:23.5,Weight:1.2,CtnrType:'20GP'},
        {CtnrID:'TCKU1364501',SKU:'MTB-2020-GN-PMFBA-1',QTY:6,Ctns:9,Length:56.5,Width:24.5,Height:51.5,Weight:19.55,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'BTC-S002-00-OMTFBA-1',QTY:50,Ctns:16,Length:52,Width:51,Height:33,Weight:18.9,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'CFS-CF89-08-BNFBA-1',QTY:15,Ctns:126,Length:58,Width:19.5,Height:14,Weight:2,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'CPF-0097-10-BNFBA-1',QTY:5,Ctns:2,Length:56,Width:33.5,Height:23.5,Weight:15.2,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'D6A-W1ST-US-SWFBA-1',QTY:4,Ctns:20,Length:55,Width:35,Height:45.5,Weight:6.65,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'FWV-0004-BK-ZLSFBA-1',QTY:1,Ctns:24,Length:27,Width:24.99,Height:8,Weight:2.15,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'FWV-0006-BK-ZLSFBA-1',QTY:1,Ctns:18,Length:27,Width:24.99,Height:9.5,Weight:3.1,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'FWV-0016-BK-ZLSFBA-1',QTY:1,Ctns:306,Length:27,Width:24.99,Height:10.49,Weight:7.63,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'FWV-1200-BK-ZLSFBA-1',QTY:1,Ctns:764,Length:27.51,Width:24.99,Height:8.99,Weight:5.75,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-1CDD-XB-OMTFBA-1',QTY:10,Ctns:27,Length:32.5,Width:25,Height:39,Weight:10.7,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-2CJD-8B-GWFBA-1',QTY:5,Ctns:15,Length:32.5,Width:22,Height:19.5,Weight:10.9,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-4CDD-5B-GWFBA-1',QTY:10,Ctns:35,Length:34,Width:25,Height:40,Weight:10,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-5CDD-5S-AMZFBA-1',QTY:10,Ctns:17,Length:32.5,Width:24,Height:37.5,Weight:10,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CEA-6S-OMTFBA-1',QTY:10,Ctns:31,Length:33,Width:25,Height:38,Weight:15.85,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CIA-6B-GWFBA-1',QTY:10,Ctns:28,Length:32.5,Width:24,Height:37.5,Weight:17.8,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CJD-6B-GWFBA-1',QTY:10,Ctns:106,Length:32.5,Width:24,Height:37.5,Weight:17.8,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CJD-6S-OMTFBA-1',QTY:10,Ctns:1,Length:33,Width:25,Height:39,Weight:17.2,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CJD-8B-GWFBA-1',QTY:5,Ctns:109,Length:32.5,Width:22,Height:19.5,Weight:11.36,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CJD-8S-GWFBA-1',QTY:5,Ctns:98,Length:32.5,Width:21.5,Height:20,Weight:10.55,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CLC-6B-OMTFBA-1',QTY:4,Ctns:45,Length:34,Width:30,Height:15,Weight:13.8,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CLC-8S-OMTFBA-1',QTY:4,Ctns:28,Length:44.5,Width:30,Height:15,Weight:18,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CLF-6S-OMTFBA-1',QTY:4,Ctns:58,Length:34,Width:29,Height:15,Weight:12.75,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CLF-8B-OMTFBA-1',QTY:4,Ctns:47,Length:44.5,Width:30,Height:15,Weight:18,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6CLF-8S-OMTFBA-1',QTY:4,Ctns:19,Length:44.5,Width:30,Height:15,Weight:16.5,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-6MHA-5B-OMTFBA-1',QTY:5,Ctns:30,Length:34,Width:25,Height:20,Weight:13.4,CtnrType:'20GP'},
        {CtnrID:'TCKU3755676',SKU:'LNS-8004-00-GWFBA-1',QTY:10,Ctns:18,Length:33,Width:24,Height:38,Weight:14,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'BJS-0010-BL-GWFBA-1',QTY:9,Ctns:1,Length:57.5,Width:28,Height:34,Weight:17.6,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'BJS-0014-00-OMTFBA-1',QTY:1,Ctns:95,Length:37,Width:32,Height:11,Weight:5.85,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'BJS-N401-BL-OMTFBA-1',QTY:1,Ctns:374,Length:37,Width:28,Height:8,Weight:7.95,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'BSN-S012-R1-BNFBA-1',QTY:2,Ctns:30,Length:31.5,Width:24,Height:22.5,Weight:11.85,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'CWB-0003-BL-GWFBA-1',QTY:10,Ctns:34,Length:32.5,Width:43,Height:18.5,Weight:14.15,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'CWB-RD22-00-GWFBA-1',QTY:1,Ctns:1600,Length:34,Width:6.5,Height:24,Weight:2.7,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'FWV-0008-BK-ZLSFBA-1',QTY:1,Ctns:361,Length:27,Width:24.99,Height:9.5,Weight:3.95,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'HRG-M1K0-3X-BNFBA-1',QTY:10,Ctns:9,Length:18,Width:46,Height:27,Weight:10,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'LNS-1CDA-5S-OMTFBA-1',QTY:10,Ctns:35,Length:32.5,Width:25,Height:39,Weight:11.5,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'LNS-4CDD-5B-GWFBA-1',QTY:10,Ctns:30,Length:34,Width:25,Height:40,Weight:10,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'LNS-5CDA-5S-OMTFBA-1',QTY:10,Ctns:9,Length:32.5,Width:25,Height:38.5,Weight:11.95,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'LNS-6CLC-6B-OMTFBA-1',QTY:4,Ctns:40,Length:34,Width:30,Height:15,Weight:13.8,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'LNS-6CLC-8S-OMTFBA-1',QTY:4,Ctns:112,Length:44.5,Width:30,Height:15,Weight:18,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'LNS-6CLF-6S-OMTFBA-1',QTY:4,Ctns:3,Length:34,Width:29,Height:15,Weight:12.75,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'MIO-0000-00-BNFBA-1',QTY:20,Ctns:19,Length:46,Width:43.99,Height:35.99,Weight:21.15,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'NSS-BE13-00-GWFBA-1',QTY:19,Ctns:1,Length:40,Width:27,Height:30,Weight:16.4,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'RGS-0000-GN-HRMFBA-1',QTY:25,Ctns:9,Length:46,Width:19.5,Height:40.5,Weight:12.35,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'SCK-0001-00-FBAOMT-1',QTY:5,Ctns:21,Length:38,Width:31,Height:23,Weight:11.36,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'SCS-N300-00-GWFBA-1',QTY:5,Ctns:39,Length:39,Width:16.5,Height:36.5,Weight:16.35,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'SCS-N300-SL-GWFBA-1',QTY:5,Ctns:48,Length:39,Width:16.5,Height:37,Weight:16.5,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'TAS-0204-N0-FBAOMT-1',QTY:18,Ctns:34,Length:57.5,Width:25,Height:13.5,Weight:10.65,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'WAS-4138-12-OMTFBA-1',QTY:1,Ctns:88,Length:30.5,Width:17.5,Height:19,Weight:6.17,CtnrType:'20GP'},
        {CtnrID:'TCLU3853216',SKU:'WFL-5G2F-DK-OMTFBA-1',QTY:1,Ctns:17,Length:35,Width:19.5,Height:14,Weight:5.15,CtnrType:'20GP'},
        {CtnrID:'TGBU4705289',SKU:'BJS-0010-BL-GWFBA-1',QTY:10,Ctns:81,Length:57.5,Width:28,Height:34,Weight:17.6,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'BJS-ZX01-BL-GWFBA-1',QTY:1,Ctns:110,Length:41.5,Width:32,Height:9.5,Weight:5.51,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'BMP-0100-58-BNFBA-1',QTY:12,Ctns:2,Length:29,Width:48,Height:52,Weight:12.45,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'CFS-CF89-08-BNFBA-1',QTY:15,Ctns:35,Length:58,Width:19.5,Height:14,Weight:2,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'DMG-2017-BU-GWFBA-1',QTY:5,Ctns:29,Length:51.5,Width:40,Height:34,Weight:18.7,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'DMG-5FTY-BU-GWFBA-1',QTY:5,Ctns:110,Length:52,Width:35,Height:25,Weight:12.4,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'DMG-5FTY-RE-GWFBA-1',QTY:5,Ctns:92,Length:52,Width:36,Height:26,Weight:12.2,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'DMG-R134-12-FBAGW-1',QTY:5,Ctns:78,Length:53,Width:33.5,Height:34.5,Weight:16.95,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'DSS-0007-00-BNFBA-1',QTY:50,Ctns:5,Length:40.01,Width:26.01,Height:37.01,Weight:13.6,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'ETT-F009-00-OMTFBA-1',QTY:1,Ctns:223,Length:29,Width:9.5,Height:24,Weight:1.7,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'HCF-1313-BZ-BNFBA-1',QTY:1,Ctns:180,Length:36,Width:36,Height:18,Weight:1.6,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'HCF-1317-CH-BNFBA-1',QTY:1,Ctns:50,Length:34,Width:34,Height:19,Weight:2,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'HCF-2805-00-BNFBA-1',QTY:1,Ctns:557,Length:30,Width:16.99,Height:17.5,Weight:0.9,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'HMG-MGYN-US-BNFBA-1',QTY:1,Ctns:33,Length:26.01,Width:18.01,Height:18.01,Weight:2.21,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'IPV-F002-01-OMTFBA-1',QTY:50,Ctns:2,Length:38,Width:30.5,Height:34.5,Weight:15.31,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'LNS-1CDA-5S-OMTFBA-1',QTY:10,Ctns:45,Length:32,Width:25,Height:38.5,Weight:11.15,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'MFK-2019-RE-GWFBA-1',QTY:10,Ctns:116,Length:46.5,Width:33,Height:31.5,Weight:10.26,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'MON-30MM-BK-GPUFBA-1',QTY:40,Ctns:9,Length:45,Width:40,Height:31,Weight:14.35,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'ORK-SM02-N0-GWFBA-1',QTY:8,Ctns:198,Length:49,Width:36,Height:28.5,Weight:11.8,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'ORK-SM02-WY-GWFBA-1',QTY:8,Ctns:37,Length:53.34,Width:38,Height:28,Weight:11.7,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'OTP-8011-00-GWFBA-1',QTY:5,Ctns:24,Length:50.5,Width:25,Height:33.7,Weight:19.1,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'PEK-0007-00-OMTFBA-1',QTY:1,Ctns:130,Length:39,Width:9.5,Height:32,Weight:4.8,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'PTL-1306-BK-BNFBA-1',QTY:1,Ctns:247,Length:18.5,Width:18.5,Height:28.5,Weight:0.82,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'PTL-1719-00-BNFBA-1',QTY:1,Ctns:60,Length:43.5,Width:33,Height:22,Weight:5.6,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'PTL-2010-00-BNFBA-1',QTY:1,Ctns:385,Length:19.99,Width:19.5,Height:31,Weight:1,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'QCW-0050-04-GWFBA-1',QTY:50,Ctns:9,Length:35,Width:28.5,Height:23.5,Weight:9.61,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'QCW-0050-RD-OMTFBA-1',QTY:100,Ctns:14,Length:35,Width:28.5,Height:23,Weight:9.15,CtnrType:'40HQ'},
        {CtnrID:'TGBU4705289',SKU:'QCW-0175-04-GWFBA-1',QTY:25,Ctns:18,Length:47,Width:47,Height:27,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'ASH-1001-BK-BNFBA-1',QTY:9,Ctns:7,Length:57,Width:57,Height:34.01,Weight:15.55,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'ASH-1002-BK-BNFBA-1',QTY:12,Ctns:6,Length:51,Width:35.5,Height:50,Weight:16.9,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'ASH-1008-BK-BNFBA-1',QTY:8,Ctns:8,Length:43,Width:43,Height:44,Weight:15.6,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'BJS-N401-BK-OMTFBA-1',QTY:1,Ctns:157,Length:37.5,Width:28,Height:8,Weight:7.85,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'BJS-N401-BL-OMTFBA-1',QTY:1,Ctns:212,Length:37,Width:28,Height:8,Weight:7.95,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'BJS-N401-RD-OMTFBA-1',QTY:1,Ctns:193,Length:37,Width:28,Height:8,Weight:8,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'D6A-BP00-US-SWFBA-1',QTY:9,Ctns:23,Length:58,Width:33,Height:59,Weight:9.35,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'D6A-COST-US-SWFBA-1',QTY:9,Ctns:9,Length:50,Width:50,Height:47,Weight:17,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'D6A-P3KI-US-SWFBA-1',QTY:9,Ctns:66,Length:63,Width:57,Height:42,Weight:16.3,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'D6A-P3ST-US-SWFBA-1',QTY:9,Ctns:66,Length:45,Width:42,Height:42,Weight:13.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'D6A-WMPI-US-SWFBA-1',QTY:9,Ctns:12,Length:63,Width:57,Height:42,Weight:16.4,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'D6A-WMST-US-SWFBA-1',QTY:9,Ctns:12,Length:63,Width:57,Height:42,Weight:12.25,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'GMR-2020-BK-ZLSFBA-1',QTY:10,Ctns:10,Length:51,Width:35,Height:27,Weight:15.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'GSQ-0009-00-OMTFBA-1',QTY:1,Ctns:66,Length:45,Width:32,Height:11,Weight:3.55,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HCF-0105-WH-BNFBA-1',QTY:1,Ctns:46,Length:19.99,Width:19.99,Height:36,Weight:1.5,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HCF-1722-00-BNFBA-1',QTY:1,Ctns:190,Length:34,Width:28,Height:19.51,Weight:1.5,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HCF-2805-00-BNFBA-1',QTY:1,Ctns:166,Length:30,Width:16.99,Height:17.5,Weight:0.9,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HCF-2805-NI-FBABN-1',QTY:1,Ctns:7,Length:30,Width:19,Height:17.5,Weight:0.8,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HMG-8502-U2-BNFBA-1',QTY:8,Ctns:5,Length:46,Width:57,Height:41,Weight:18.8,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HMG-JJ01-U2-BNFBA-1',QTY:1,Ctns:30,Length:45,Width:17.5,Height:34,Weight:7.75,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HRG-5430-BK-HRMFBA-1',QTY:50,Ctns:9,Length:49,Width:26,Height:36,Weight:16.46,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HRS-0005-00-BNFBA-1',QTY:10,Ctns:8,Length:46.99,Width:36.5,Height:30.99,Weight:13.15,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HRS-0005-G5-FBA-1',QTY:10,Ctns:4,Length:48.01,Width:38,Height:30.99,Weight:13.56,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'HRS-1650-77-BNFBA-1',QTY:10,Ctns:5,Length:37,Width:29,Height:46,Weight:14,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'KNC-LSCL-1G-BNFBA-1',QTY:50,Ctns:1,Length:41,Width:36,Height:20,Weight:4.7,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'LNS-2CJD-8S-GWFBA-1',QTY:5,Ctns:10,Length:32.5,Width:21.5,Height:20.5,Weight:10.5,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'LNS-5MGA-6B-GWFBA-1',QTY:10,Ctns:17,Length:32.5,Width:24,Height:37.5,Weight:19.96,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'LNS-6CAB-6S-OMTFBA-1',QTY:10,Ctns:44,Length:32.5,Width:24,Height:37.5,Weight:8.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'LPF-N000-ST-GWFBA-1',QTY:30,Ctns:3,Length:50,Width:36,Height:37,Weight:11.1,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'LPF-N0PK-00-GWFBA-1',QTY:30,Ctns:7,Length:50,Width:36,Height:37.5,Weight:13.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'MCJ-0000-BK-BNFBA-1',QTY:3,Ctns:13,Length:61,Width:32,Height:47,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'MCJ-0000-GY-BNFBA-1',QTY:3,Ctns:57,Length:60.5,Width:31.5,Height:47.5,Weight:20,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'MCJ-0000-OG-BNFBA-1',QTY:3,Ctns:17,Length:60,Width:31,Height:47,Weight:20.05,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'MCJ-0000-RD-BNFBA-1',QTY:3,Ctns:49,Length:61,Width:32,Height:47,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'MIO-0039-05-BNFBA-1',QTY:25,Ctns:11,Length:43,Width:38.5,Height:44.5,Weight:17.1,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'MON-LEVE-BK-HRMFBA-1',QTY:50,Ctns:5,Length:50,Width:28.5,Height:17,Weight:10.25,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'MON-LEVE-YL-HRMFBA-1',QTY:50,Ctns:3,Length:50,Width:28.5,Height:17,Weight:10.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'PAP-0006-BS-GWFBA-1',QTY:4,Ctns:33,Length:38,Width:35,Height:30,Weight:19.95,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'PAP-0006-RD-GWFBA-1',QTY:4,Ctns:27,Length:38,Width:35,Height:30.5,Weight:20,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'PUL-0046-00-GWFBA-1',QTY:5,Ctns:18,Length:30,Width:29,Height:24,Weight:11,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'PUL-SP04-00-GWFBA-1',QTY:10,Ctns:16,Length:42,Width:26,Height:34,Weight:11.1,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'QCW-0050-04-GWFBA-1',QTY:50,Ctns:4,Length:35,Width:28.5,Height:23.5,Weight:9.61,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'QCW-0175-04-GWFBA-1',QTY:25,Ctns:11,Length:47,Width:47,Height:27,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'RLS-0004-00-FBA-1',QTY:150,Ctns:3,Length:46,Width:21.01,Height:42.01,Weight:6.32,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'RLS-0011-00-BNFBA-1',QTY:100,Ctns:3,Length:50.01,Width:26.01,Height:24.99,Weight:6.38,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'SVA-L001-GY-OMTFBA-1',QTY:10,Ctns:10,Length:53,Width:45,Height:43,Weight:12,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'SVA-LW02-GY-OMTFBA-1',QTY:20,Ctns:8,Length:58.5,Width:43,Height:42,Weight:18.3,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'WAS-0005-02-GWFBA-1',QTY:1,Ctns:185,Length:35,Width:19.99,Height:16.99,Weight:6.9,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'WAS-N004-00-FBAGW-1',QTY:2,Ctns:150,Length:22,Width:18,Height:19,Weight:4.3,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'WAS-N019-2S-GWFBA-1',QTY:1,Ctns:142,Length:22,Width:17.8,Height:18.5,Weight:5.7,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'WCR-HR08-00-GWFBA-1',QTY:1,Ctns:128,Length:28,Width:26,Height:9,Weight:6.8,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'WKC-0000-00-BNFBA-1',QTY:21,Ctns:21,Length:32.5,Width:32,Height:13,Weight:5.84,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'XSC-A000-00-FBABN-1',QTY:40,Ctns:19,Length:41,Width:25.5,Height:17.5,Weight:5.15,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'XST-7101-S1-BNFBA-1',QTY:3,Ctns:3,Length:54,Width:28,Height:37,Weight:6.8,CtnrType:'40HQ'},
        {CtnrID:'TLLU4021034',SKU:'YSS-N001-BK-BNFBA-1',QTY:8,Ctns:4,Length:55,Width:32,Height:40,Weight:20.8,CtnrType:'40HQ'},
        {CtnrID:'TRLU9132031',SKU:'BJS-N401-BK-OMTFBA-1',QTY:1,Ctns:1321,Length:37.5,Width:28,Height:8,Weight:7.85,CtnrType:'20GP'},
        {CtnrID:'TRLU9132031',SKU:'CWB-RD22-BK-GWFBA-1',QTY:5,Ctns:426,Length:34.01,Width:32.5,Height:24.5,Weight:13.9,CtnrType:'20GP'},
        {CtnrID:'TRLU9132031',SKU:'HRS-0011-GN-FBABN-1',QTY:10,Ctns:70,Length:48.01,Width:38,Height:32,Weight:13.14,CtnrType:'20GP'},
        {CtnrID:'TRLU9132031',SKU:'HRS-0015-00-GPUFBA-1',QTY:8,Ctns:13,Length:54,Width:41,Height:30.99,Weight:15.55,CtnrType:'20GP'},
        {CtnrID:'WHSU5576612',SKU:'AOL-0005-01-BNFBA-1',QTY:15,Ctns:18,Length:45.01,Width:43.99,Height:30,Weight:16.76,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'BIP-MOUN-4P-BNFBA-1',QTY:40,Ctns:3,Length:44.5,Width:39.5,Height:28,Weight:22.3,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'BIP-MOUN-DD-BNFBA-1',QTY:50,Ctns:6,Length:48,Width:40,Height:33,Weight:22.5,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'BJS-0010-00-OMTFBA-1',QTY:10,Ctns:213,Length:57.5,Width:28,Height:34,Weight:17.3,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'BJS-ZX01-02-GWFBA-1',QTY:1,Ctns:705,Length:34.01,Width:26,Height:12.5,Weight:5.15,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'BTC-S002-00-OMTFBA-1',QTY:50,Ctns:5,Length:52,Width:51,Height:33,Weight:18.9,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'CFS-CF89-16-BNFBA-1',QTY:15,Ctns:49,Length:51.5,Width:33.8,Height:21,Weight:4.15,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'DMG-2019-03-GWFBA-1',QTY:12,Ctns:49,Length:45.01,Width:30.99,Height:42.01,Weight:21.75,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'ETT-NN07-BL-OMTFBA-1',QTY:10,Ctns:31,Length:49,Width:33,Height:46,Weight:19.6,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'GMB-0000-00-BNFBA-1',QTY:20,Ctns:10,Length:54,Width:45.5,Height:30,Weight:17.5,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'GSQ-0009-00-OMTFBA-1',QTY:1,Ctns:429,Length:45,Width:32,Height:11,Weight:3.55,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'HCF-2805-00-BNFBA-1',QTY:1,Ctns:9,Length:30,Width:16.99,Height:17.5,Weight:0.9,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'HNC-LSL8-GR-BNFBA-1',QTY:50,Ctns:73,Length:51.5,Width:32,Height:15.5,Weight:4.05,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'LNS-1CIA-5S-OMTFBA-1',QTY:10,Ctns:85,Length:32.5,Width:24,Height:37.5,Weight:13.2,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'LNS-5CDA-5S-OMTFBA-1',QTY:10,Ctns:71,Length:32.5,Width:25,Height:38.5,Weight:11.95,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'MCJ-0000-BK-BNFBA-1',QTY:3,Ctns:100,Length:61,Width:32,Height:47,Weight:20.2,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'PAP-0006-BS-GWFBA-1',QTY:4,Ctns:43,Length:38,Width:35,Height:30,Weight:19.95,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'SVA-L001-BE-OMTFBA-1',QTY:20,Ctns:21,Length:59,Width:44,Height:43,Weight:14.25,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'SVA-L001-GY-OMTFBA-1',QTY:10,Ctns:55,Length:53,Width:45,Height:43,Weight:12,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'SVA-LW01-GY-OMTFBA-1',QTY:20,Ctns:23,Length:58.5,Width:43.5,Height:41.5,Weight:14.75,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'SVA-LW02-GY-OMTFBA-1',QTY:20,Ctns:6,Length:60,Width:43.5,Height:44.5,Weight:18.6,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'SVA-R001-BE-OMTFBA-1',QTY:20,Ctns:7,Length:59,Width:44,Height:43,Weight:14.55,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'SVA-RW01-GY-OMTFBA-1',QTY:20,Ctns:15,Length:57.99,Width:43,Height:43,Weight:14.65,CtnrType:'40HQ'},
        {CtnrID:'WHSU5576612',SKU:'TAD-M040-00-OMTFBA-1',QTY:10,Ctns:19,Length:36,Width:45,Height:33,Weight:16,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'AZK-FWS1-04-GWFBA-1',QTY:50,Ctns:4,Length:53,Width:23,Height:29,Weight:13,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'BSN-S036-RD-BNFBA-1',QTY:4,Ctns:110,Length:32.5,Width:24.5,Height:19.96,Weight:11.9,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'BTG-0100-00-OMTFBA-1',QTY:10,Ctns:143,Length:34,Width:36,Height:44,Weight:13.45,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'CPF-0097-10-BNFBA-1',QTY:5,Ctns:28,Length:56,Width:33.5,Height:23.5,Weight:15.2,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'DKK-VGG1-80-BILIFBA-1',QTY:20,Ctns:23,Length:50.01,Width:43.99,Height:23.01,Weight:13.05,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'DSS-2018-01-BNFBA-1',QTY:50,Ctns:2,Length:42.01,Width:23.01,Height:34.01,Weight:12.45,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'ETT-EA88-N1-GWFBA-1',QTY:1,Ctns:5,Length:30,Width:24,Height:9.3,Weight:1.75,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'FTK-0010-RD-GWFBA-1',QTY:8,Ctns:41,Length:42,Width:40.5,Height:22.5,Weight:21.35,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'FWV-0006-BK-ZLSFBA-1',QTY:1,Ctns:58,Length:27,Width:24.99,Height:9.5,Weight:3.1,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'GLS-0000-GR-BNFBA-1',QTY:25,Ctns:55,Length:51.99,Width:29.01,Height:27.99,Weight:8.35,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'HCF-2805-NI-FBABN-1',QTY:1,Ctns:426,Length:30,Width:19,Height:17.5,Weight:0.8,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'JJD-0102-US-BNFBA-1',QTY:16,Ctns:15,Length:36.5,Width:31,Height:22,Weight:12.3,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'JWQ-BMW1-01-GWFBA-1',QTY:30,Ctns:10,Length:57,Width:30,Height:47,Weight:16.9,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'KSH-S002-01-OMTFBA-1',QTY:50,Ctns:4,Length:52,Width:31.5,Height:37.5,Weight:18.5,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'LNS-6CLF-8S-OMTFBA-1',QTY:4,Ctns:57,Length:45,Width:30,Height:15,Weight:17.1,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'MAS-J064-00-BNFBA-1',QTY:1,Ctns:466,Length:33,Width:24.5,Height:6.5,Weight:3.1,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'MFK-2019-RE-GWFBA-1',QTY:10,Ctns:26,Length:46.5,Width:33,Height:31.5,Weight:10.26,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'PAP-0006-BS-GWFBA-1',QTY:4,Ctns:20,Length:38,Width:35,Height:30,Weight:19.95,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'PAP-0006-RD-GWFBA-1',QTY:4,Ctns:127,Length:38,Width:35,Height:30.5,Weight:20,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'PAP-S004-00-OMTFBA-1',QTY:1,Ctns:6,Length:34.5,Width:12.5,Height:10,Weight:4.6,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'SDC-0012-BK-FBABN-1',QTY:6,Ctns:155,Length:57.5,Width:44.8,Height:38,Weight:13.3,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'SDC-N008-BK-BNFBA-1',QTY:10,Ctns:133,Length:57,Width:55,Height:38,Weight:12.55,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'SDS-2020-3P-BNFBA-1',QTY:4,Ctns:146,Length:37.5,Width:25.5,Height:16,Weight:6.45,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'TAS-0100-00-GWFBA-1',QTY:18,Ctns:7,Length:57,Width:25,Height:13,Weight:6.61,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'TAS-0205-00-GWFBA-1',QTY:18,Ctns:1,Length:57.4,Width:24.4,Height:13,Weight:10.3,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'WAS-N019-2S-GWFBA-1',QTY:1,Ctns:122,Length:22,Width:17.8,Height:18.5,Weight:5.7,CtnrType:'40HQ'},
        {CtnrID:'YMLU8528364',SKU:'XST-7101-S1-BNFBA-1',QTY:3,Ctns:1,Length:54,Width:29,Height:37,Weight:6.8,CtnrType:'40HQ'}
    ];
export const warehouseTemp= [
    {vendor:'Smart3PL',srvPort:'Long Beach',chargeType:'Standard',chargeDescription:'Inbound Unload',rateType:'Simple',ctnrType:'20GP',uom:'per Load',rates:350,tieredJson:'NA',currency:'USD'},
    {vendor:'Smart3PL',srvPort:'Long Beach',chargeType:'Standard',chargeDescription:'Inbound Unload',rateType:'Simple',ctnrType:'40GP',uom:'per Load',rates:450,tieredJson:'NA',currency:'USD'},
    {vendor:'Smart3PL',srvPort:'Long Beach',chargeType:'Standard',chargeDescription:'Inbound Unload',rateType:'Simple',ctnrType:'40HQ',uom:'per Load',rates:450,tieredJson:'NA',currency:'USD'},
    {vendor:'Smart3PL',srvPort:'Long Beach',chargeType:'Standard',chargeDescription:'Inbound Unload',rateType:'Simple',ctnrType:'45HQ',uom:'per Load',rates:500,tieredJson:'NA',currency:'USD'},
    {vendor:'Smart3PL',srvPort:'Long Beach',chargeType:'Standard',chargeDescription:'Storage',rateType:'Simple',ctnrType:'All',uom:'per cbm per day',rates:0.5,tieredJson:'NA',currency:'USD'},
    {vendor:'Smart3PL',srvPort:'Long Beach',chargeType:'Standard',chargeDescription:'Palletization',rateType:'Simple',ctnrType:'All',uom:'per Pallet',rates:18,tieredJson:'NA',currency:'USD'},
    {vendor:'Smart3PL',srvPort:'Long Beach',chargeType:'VAS',chargeDescription:'Labelling',rateType:'Simple',ctnrType:'All',uom:'per Label',rates:0.25,tieredJson:'NA',currency:'USD'},
];
export const upsBaseRates=[
    {Weight:1,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone44:12.05,Zone45:12.69,Zone46:15.89},
    {Weight:2,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone44:13.41,Zone45:14.21,Zone46:17.24},
    {Weight:3,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone44:14.57,Zone45:16.19,Zone46:18.35},
    {Weight:4,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone44:16.01,Zone45:17.26,Zone46:19.9},
    {Weight:5,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone44:17.34,Zone45:18.74,Zone46:21.17},
    {Weight:6,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone44:18.72,Zone45:19.94,Zone46:21.99},
    {Weight:7,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.24,Zone44:19.99,Zone45:21.48,Zone46:23.11},
    {Weight:8,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.51,Zone44:20.71,Zone45:22.59,Zone46:24.31},
    {Weight:9,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.32,Zone8:6.86,Zone44:22.17,Zone45:24.17,Zone46:25.77},
    {Weight:10,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.62,Zone8:7.31,Zone44:23.55,Zone45:26.24,Zone46:27.15},
    {Weight:11,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.69,Zone8:7.27,Zone44:23.27,Zone45:26.07,Zone46:26.67},
    {Weight:12,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.96,Zone8:7.6,Zone44:24.28,Zone45:27.02,Zone46:27.65},
    {Weight:13,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:7.41,Zone8:7.98,Zone44:25.28,Zone45:28,Zone46:28.64},
    {Weight:14,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.42,Zone7:7.91,Zone8:8.63,Zone44:26.33,Zone45:29.1,Zone46:29.68},
    {Weight:15,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.77,Zone7:8.15,Zone8:9.03,Zone44:27.3,Zone45:30.41,Zone46:30.63},
    {Weight:16,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:7,Zone7:8.59,Zone8:9.43,Zone44:28.52,Zone45:31.69,Zone46:31.85},
    {Weight:17,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.15,Zone6:7.29,Zone7:9.02,Zone8:9.57,Zone44:29.73,Zone45:33.2,Zone46:32.85},
    {Weight:18,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.44,Zone6:7.67,Zone7:9.29,Zone8:10.22,Zone44:30.96,Zone45:35.18,Zone46:34.07},
    {Weight:19,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.72,Zone6:7.86,Zone7:9.55,Zone8:10.64,Zone44:32.18,Zone45:36.31,Zone46:35.28},
    {Weight:20,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.99,Zone6:8.13,Zone7:9.9,Zone8:11.1,Zone44:33.26,Zone45:37.64,Zone46:36.35},

];
export const fdxBaseRates=[
    {Weight:1,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:12.05,ToHI:12.69},
    {Weight:2,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:13.41,ToHI:14.21},
    {Weight:3,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:14.57,ToHI:16.19},
    {Weight:4,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:16.01,ToHI:17.26},
    {Weight:5,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:17.34,ToHI:18.74},
    {Weight:6,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:18.72,ToHI:19.94},
    {Weight:7,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.24,ToAK:19.99,ToHI:21.48},
    {Weight:8,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.51,ToAK:20.71,ToHI:22.59},
    {Weight:9,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.32,Zone8:6.86,ToAK:22.17,ToHI:24.17},
    {Weight:10,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.62,Zone8:7.31,ToAK:23.55,ToHI:26.24},

];
export const uspsBaseRates=[
    {Weight:1,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone9:12.05,NC6:12.05,NC7:12.69,NC8:15.89},
    {Weight:2,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone9:13.41,NC6:13.41,NC7:14.21,NC8:17.24},
    {Weight:3,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone9:14.57,NC6:14.57,NC7:16.19,NC8:18.35},
    {Weight:4,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone9:16.01,NC6:16.01,NC7:17.26,NC8:19.9},
    {Weight:5,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone9:17.34,NC6:17.34,NC7:18.74,NC8:21.17},
    {Weight:6,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,Zone9:18.72,NC6:18.72,NC7:19.94,NC8:21.99},
    {Weight:7,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.24,Zone9:19.99,NC6:19.99,NC7:21.48,NC8:23.11},
    {Weight:8,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.51,Zone9:20.71,NC6:20.71,NC7:22.59,NC8:24.31},
    {Weight:9,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.32,Zone8:6.86,Zone9:22.17,NC6:22.17,NC7:24.17,NC8:25.77},
    {Weight:10,Unit:'OZ',Zone1:6.09,Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.62,Zone8:7.31,Zone9:23.55,NC6:23.55,NC7:26.24,NC8:27.15},
    {Weight:11,Unit:'OZ',Zone1:7.09,Zone2:7.09,Zone3:7.09,Zone4:7.09,Zone5:7.09,Zone6:7.09,Zone7:7.62,Zone8:8.31,Zone9:24.55,NC6:24.55,NC7:27.24,NC8:28.15},
    {Weight:12,Unit:'OZ',Zone1:8.09,Zone2:8.09,Zone3:8.09,Zone4:8.09,Zone5:8.09,Zone6:8.09,Zone7:8.62,Zone8:9.31,Zone9:25.55,NC6:25.55,NC7:28.24,NC8:29.15},
    {Weight:13,Unit:'OZ',Zone1:9.09,Zone2:9.09,Zone3:9.09,Zone4:9.09,Zone5:9.09,Zone6:9.09,Zone7:9.62,Zone8:10.31,Zone9:26.55,NC6:26.55,NC7:29.24,NC8:30.15},
    {Weight:14,Unit:'OZ',Zone1:10.09,Zone2:10.09,Zone3:10.09,Zone4:10.09,Zone5:10.09,Zone6:10.09,Zone7:10.62,Zone8:11.31,Zone9:27.55,NC6:27.55,NC7:30.24,NC8:31.15},
    {Weight:15,Unit:'OZ',Zone1:11.09,Zone2:11.09,Zone3:11.09,Zone4:11.09,Zone5:11.09,Zone6:11.09,Zone7:11.62,Zone8:12.31,Zone9:28.55,NC6:28.55,NC7:31.24,NC8:32.15},
    {Weight:16,Unit:'OZ',Zone1:12.09,Zone2:12.09,Zone3:12.09,Zone4:12.09,Zone5:12.09,Zone6:12.09,Zone7:12.62,Zone8:13.31,Zone9:29.55,NC6:29.55,NC7:32.24,NC8:33.15},
    {Weight:1,Unit:'LB',Zone1:13.09,Zone2:13.09,Zone3:13.09,Zone4:13.09,Zone5:13.09,Zone6:13.09,Zone7:13.62,Zone8:14.31,Zone9:30.55,NC6:30.55,NC7:33.24,NC8:34.15},
    {Weight:2,Unit:'LB',Zone1:14.09,Zone2:14.09,Zone3:14.09,Zone4:14.09,Zone5:14.09,Zone6:14.09,Zone7:14.62,Zone8:15.31,Zone9:31.55,NC6:31.55,NC7:34.24,NC8:35.15},
    {Weight:3,Unit:'LB',Zone1:15.09,Zone2:15.09,Zone3:15.09,Zone4:15.09,Zone5:15.09,Zone6:15.09,Zone7:15.62,Zone8:16.31,Zone9:32.55,NC6:32.55,NC7:35.24,NC8:36.15},
    {Weight:4,Unit:'LB',Zone1:16.09,Zone2:16.09,Zone3:16.09,Zone4:16.09,Zone5:16.09,Zone6:16.09,Zone7:16.62,Zone8:17.31,Zone9:33.55,NC6:33.55,NC7:36.24,NC8:37.15},
    {Weight:5,Unit:'LB',Zone1:17.09,Zone2:17.09,Zone3:17.09,Zone4:17.09,Zone5:17.09,Zone6:17.09,Zone7:17.62,Zone8:18.31,Zone9:34.55,NC6:34.55,NC7:37.24,NC8:38.15},
    {Weight:6,Unit:'LB',Zone1:18.09,Zone2:18.09,Zone3:18.09,Zone4:18.09,Zone5:18.09,Zone6:18.09,Zone7:18.62,Zone8:19.31,Zone9:35.55,NC6:35.55,NC7:38.24,NC8:39.15},
    {Weight:7,Unit:'LB',Zone1:19.09,Zone2:19.09,Zone3:19.09,Zone4:19.09,Zone5:19.09,Zone6:19.09,Zone7:19.62,Zone8:20.31,Zone9:36.55,NC6:36.55,NC7:39.24,NC8:40.15},
    {Weight:8,Unit:'LB',Zone1:20.09,Zone2:20.09,Zone3:20.09,Zone4:20.09,Zone5:20.09,Zone6:20.09,Zone7:20.62,Zone8:21.31,Zone9:37.55,NC6:37.55,NC7:40.24,NC8:41.15},
    {Weight:9,Unit:'LB',Zone1:21.09,Zone2:21.09,Zone3:21.09,Zone4:21.09,Zone5:21.09,Zone6:21.09,Zone7:21.62,Zone8:22.31,Zone9:38.55,NC6:38.55,NC7:41.24,NC8:42.15},
    {Weight:10,Unit:'LB',Zone1:22.09,Zone2:22.09,Zone3:22.09,Zone4:22.09,Zone5:22.09,Zone6:22.09,Zone7:22.62,Zone8:23.31,Zone9:39.55,NC6:39.55,NC7:42.24,NC8:43.15},
    {Weight:11,Unit:'LB',Zone1:23.09,Zone2:23.09,Zone3:23.09,Zone4:23.09,Zone5:23.09,Zone6:23.09,Zone7:23.62,Zone8:24.31,Zone9:40.55,NC6:40.55,NC7:43.24,NC8:44.15},
    {Weight:12,Unit:'LB',Zone1:24.09,Zone2:24.09,Zone3:24.09,Zone4:24.09,Zone5:24.09,Zone6:24.09,Zone7:24.62,Zone8:25.31,Zone9:41.55,NC6:41.55,NC7:44.24,NC8:45.15},
    {Weight:13,Unit:'LB',Zone1:25.09,Zone2:25.09,Zone3:25.09,Zone4:25.09,Zone5:25.09,Zone6:25.09,Zone7:25.62,Zone8:26.31,Zone9:42.55,NC6:42.55,NC7:45.24,NC8:46.15},
];
export const uspsPeakFeeTemp=[
    {Weight:1,Unit:'LB',Zone1:13.09,Zone2:13.09,Zone3:13.09,Zone4:13.09,Zone5:13.09,Zone6:13.09,Zone7:13.62,Zone8:14.31,Zone9:30.55,NC6:30.55,NC7:33.24,NC8:34.15},
    {Weight:2,Unit:'LB',Zone1:14.09,Zone2:14.09,Zone3:14.09,Zone4:14.09,Zone5:14.09,Zone6:14.09,Zone7:14.62,Zone8:15.31,Zone9:31.55,NC6:31.55,NC7:34.24,NC8:35.15},
    {Weight:3,Unit:'LB',Zone1:15.09,Zone2:15.09,Zone3:15.09,Zone4:15.09,Zone5:15.09,Zone6:15.09,Zone7:15.62,Zone8:16.31,Zone9:32.55,NC6:32.55,NC7:35.24,NC8:36.15},
    {Weight:4,Unit:'LB',Zone1:16.09,Zone2:16.09,Zone3:16.09,Zone4:16.09,Zone5:16.09,Zone6:16.09,Zone7:16.62,Zone8:17.31,Zone9:33.55,NC6:33.55,NC7:36.24,NC8:37.15},
    {Weight:5,Unit:'LB',Zone1:17.09,Zone2:17.09,Zone3:17.09,Zone4:17.09,Zone5:17.09,Zone6:17.09,Zone7:17.62,Zone8:18.31,Zone9:34.55,NC6:34.55,NC7:37.24,NC8:38.15},
    {Weight:6,Unit:'LB',Zone1:18.09,Zone2:18.09,Zone3:18.09,Zone4:18.09,Zone5:18.09,Zone6:18.09,Zone7:18.62,Zone8:19.31,Zone9:35.55,NC6:35.55,NC7:38.24,NC8:39.15},
    {Weight:7,Unit:'LB',Zone1:19.09,Zone2:19.09,Zone3:19.09,Zone4:19.09,Zone5:19.09,Zone6:19.09,Zone7:19.62,Zone8:20.31,Zone9:36.55,NC6:36.55,NC7:39.24,NC8:40.15},
    {Weight:8,Unit:'LB',Zone1:20.09,Zone2:20.09,Zone3:20.09,Zone4:20.09,Zone5:20.09,Zone6:20.09,Zone7:20.62,Zone8:21.31,Zone9:37.55,NC6:37.55,NC7:40.24,NC8:41.15},
    {Weight:9,Unit:'LB',Zone1:21.09,Zone2:21.09,Zone3:21.09,Zone4:21.09,Zone5:21.09,Zone6:21.09,Zone7:21.62,Zone8:22.31,Zone9:38.55,NC6:38.55,NC7:41.24,NC8:42.15},
    {Weight:10,Unit:'LB',Zone1:22.09,Zone2:22.09,Zone3:22.09,Zone4:22.09,Zone5:22.09,Zone6:22.09,Zone7:22.62,Zone8:23.31,Zone9:39.55,NC6:39.55,NC7:42.24,NC8:43.15},
    {Weight:11,Unit:'LB',Zone1:23.09,Zone2:23.09,Zone3:23.09,Zone4:23.09,Zone5:23.09,Zone6:23.09,Zone7:23.62,Zone8:24.31,Zone9:40.55,NC6:40.55,NC7:43.24,NC8:44.15},
    {Weight:12,Unit:'LB',Zone1:24.09,Zone2:24.09,Zone3:24.09,Zone4:24.09,Zone5:24.09,Zone6:24.09,Zone7:24.62,Zone8:25.31,Zone9:41.55,NC6:41.55,NC7:44.24,NC8:45.15},
    {Weight:13,Unit:'LB',Zone1:25.09,Zone2:25.09,Zone3:25.09,Zone4:25.09,Zone5:25.09,Zone6:25.09,Zone7:25.62,Zone8:26.31,Zone9:42.55,NC6:42.55,NC7:45.24,NC8:46.15},
];
export const expAHSTemp=[
    {ChargeDesc:'AHSWeight',Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:12.05,ToHI:12.69},
    {ChargeDesc:'AHSLength',Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:13.41,ToHI:14.21},
    {ChargeDesc:'AHSWidth',Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:14.57,ToHI:16.19},
    {ChargeDesc:'AHSLengGirth',Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:16.01,ToHI:17.26},
    {ChargeDesc:'AHSPackaging',Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:17.34,ToHI:18.74},
    {ChargeDesc:'LPSLengthCom',Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.09,ToAK:18.72,ToHI:19.94},
    {ChargeDesc:'LPSLengthRes',Zone2:6.09,Zone3:6.09,Zone4:6.09,Zone5:6.09,Zone6:6.09,Zone7:6.09,Zone8:6.24,ToAK:19.99,ToHI:21.48},

];
export const oceanFreightTemp=[
    {POL:'Ningbo',POD:'Long Beach',IPI:'yes/no',Carrier:'SLS',Remark:'Long Beach-SSA-8WD',C2:'Direct-36',C20GP:2100,C40GP:0,C40HQ:2800,C45HQ:3000},
    {POL:'Shanghai',POD:'Los Angeles',IPI:'yes/no',Carrier:'YML',Remark:'Los Angeles-APM-10CD',C2:'Direct-32',C20GP:3375,C40GP:4215,C40HQ:4215,C45HQ:4465},
];
export const usCouriers=['UPS','FDX','USPS'];
export const upsProduct=['Ground','Ground Com','Ground Res','Simple Rate','NDA','EXPT'];
export const fdxProduct=['Ground','Home Delivery','2Day','SameDay'];
export const uspsProduct=['Ground Advantage','Priority Mail','Priority Mail Express','First-Class Mail'];
export const vinIdList=['9445','9446']
const activeStatusEN=[{value:'01 - Active',label:'01 - Active'},{value:'02 - Inactive',label: '02 - Inactive'}];
const activeStatusCN=[{value:'01 - Active',label:'01 - 使用中'},{value:'02 - Inactive',label: '02 - 未使用'}]
export const vinStatusList={en:activeStatusEN,cn:activeStatusCN}
export const whsStatusList={en:activeStatusEN,cn:activeStatusCN}
export const workingDaysList={
    en:[{value:'01 - Mon-Fri',label:'01 - Mon-Fri'},
        {value:'02 - Mon-Sat',label:'02 - Mon-Sat'},
        {value:'03 - Mon-Sun',label:'03 - Mon-Sun'},
        {value:'04 - Others',label:'04 - Others'}
       ],
    cn:[{value:'01 - Mon-Fri',label:'01 - 周1-5'},
        {value:'02 - Mon-Sat',label:'02 - 周1-6'},
        {value:'03 - Mon-Sun',label:'03 - 周1-7'},
        {value:'04 - Others',label:'04 - 其他'}
    ]
}
const yesNoStatusEN=[{value:'01 - Yes',label:'01 - Yes'},{value:'02 - No',label: '02 - No'},{value:'03 - TBD',label: '03 - TBD'}]
const yesNoStatusCN=[{value:'01 - Yes',label:'01 - 是'},{value:'02 - No',label: '02 - 否'},{value:'03 - TBD',label: '03 - 待定'}]
export const yesNoStatusList={en:yesNoStatusEN,cn:yesNoStatusCN}



